{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "tab": {
    "players": "Players",
    "qr": "QR Link"
  },
  "tournaments": {
    "title": "Tournaments",
    "loading": "Loading tours...",
    "menuLabel": "Tour options",
    "showFinished": "Show finished",
    "hideFinished": "Hide finished",
    "showFinishedSingleRounds": "Show finished single rounds",
    "hideFinishedSingleRounds": "Hide finished single rounds",
    "statusContinue": "Continue",
    "statusPause": "Pause",
    "statusArchive": "Archive",
    "statusSleep": "Sleep",
    "statusCancel": "Cancel",
    "statusDelete": "Delete",
    "deleteConfirmTitle": "Delete tour?",
    "deleteConfirmMessage": "\"{name}\" will be removed from your tours. This cannot be undone.",
    "deleteConfirmCta": "Delete",
    "deleteConfirmKeep": "Keep",
    "deleteRoundConfirmTitle": "Delete round?",
    "deleteRoundConfirmMessage": "\"{name}\" will be removed from your rounds. This cannot be undone.",
    "statusUpdateSent": "Updating status to {status}...",
    "statusUpdateAck": "Tour status updated.",
    "statusUpdateFailed": "Could not update the tour status.",
    "statusUpdateQueued": "Waiting for websocket...",
    "archiveTitle": "Tour updated",
    "archiveMessage": "Tour status was updated.",
    "loadError": "Unable to load tours.",
    "empty": "No tours found. Create a new one.",
    "noTours": "No tours found.",
    "defaultName": "New tour",
    "namePlaceholder": "Tour name",
    "createTitle": "New tour",
    "nameLabel": "Name",
    "nameRequired": "Give the tour a name first.",
    "createConfirm": "Create",
    "createCancel": "Cancel",
    "statusFinish": "Finish tour",
    "statusFinishConfirm": "Finish this tour? Final standings are locked in and tour points are awarded. You can reopen it later.",
    "statusReopen": "Reopen tour",
    "statusFinishRound": "Finish round",
    "statusFinishRoundConfirm": "Finish this round? The scores are locked in and the results are calculated.",
    "roundMenuLabel": "Round options",
    "creating": "Creating tour...",
    "createCta": "New tour",
    "singleRoundCta": "Single round",
    "createdNotice": "New tour created. Select it from the list.",
    "createdWithId": "Tour created: {id}",
    "createFailed": "Unable to create tour right now. Try again.",
    "membersTitle": "Tour members",
    "membersLoading": "Loading players...",
    "membersCount": "Selected: {selected}/{max}",
    "membersLoadError": "Unable to load platform players.",
    "playerProvisioning": "Setting up your player profile...",
    "playerProvisioningRetry": "Player profile setup is delayed. Try again.",
    "playerProvisioningTimeout": "Player profile setup timed out. Retry to continue.",
    "playerProvisioningActionRetry": "Retry player setup",
    "playerProvisioningBlocked": "Wait until your player profile is ready before creating a tour.",
    "creatorMemberLocked": "Your player is always part of the tour and cannot be removed.",
    "creatorMemberRequired": "Your player profile must be included before creating a tour.",
    "shareCta": "Share",
    "shareTitle": "Share {name}",
    "shareSubtitle": "Anyone with this link can view live tour results.",
    "shareAction": "Share link",
    "shareClose": "Close",
    "shareLoadError": "Unable to create an invite link for this tour.",
    "shareSendError": "Unable to share invite link on this device.",
    "shareCopied": "Invite link copied to clipboard.",
    "openButton": "Open",
    "newRoundCta": "Add round",
    "roundsTitle": "Rounds",
    "unfinishedRoundsTitle": "Unfinished rounds",
    "hiddenToursSingleRoundsTitle": "Single rounds",
    "roundsLoading": "Loading rounds...",
    "roundsEmpty": "No rounds found.",
    "roundsLoadError": "Unable to load rounds.",
    "myToursAndRoundsSummary": "Tours: {tours} · Unfinished rounds on tours: {rounds}",
    "roundFallbackName": "Round",
    "roundOpen": "Open",
    "roundStart": "Start",
    "roundUpdate": "Update",
    "roundSettings": "Round settings",
    "tourSettings": "Tour settings",
    "roundResults": "Results",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Edit",
    "gamesTitle": "Games",
    "gamesCount": "{count} games",
    "gamesLoading": "Loading games...",
    "gamesEmpty": "No games selected.",
    "gamesLoadError": "Unable to load games.",
    "groupsLoading": "Loading groups...",
    "groupsLoadError": "Unable to load groups.",
    "gameFallbackName": "Game",
    "gameTypeUnknown": "Other",
    "gameTypeLabel": "Type:",
    "gameTypeMissing": "Type: Unknown",
    "gameWeightLabel": "Weight",
    "gameDetailsTitle": "Game details",
    "gameDetailsEmpty": "No description available.",
    "gameCalculationLabel": "Calculation:",
    "addGame": "Add game",
    "addGameTitle": "Add game",
    "addGameEmpty": "All games already added."
  },
  "tourEdit": {
    "playersTitle": "Players",
    "addPlayer": "Add player",
    "removePlayer": "Remove",
    "playerCreateTemporary": "Create temporary",
    "playerTemporarySelected": "Temporary selected",
    "playerSearchPlaceholder": "Search player",
    "playerCurrentUserFallback": "You",
    "playerConfirmSelectOrTemporary": "Select an existing player or mark as temporary before confirming.",
    "playerConfirmEmpty": "Enter a player name before confirming.",
    "playerAlreadyInTour": "Player is already in the tour.",
    "playerConfirmA11y": "Confirm player row",
    "playerCancelA11y": "Cancel player row",
    "playerTemporaryToggleA11y": "Toggle temporary player",
    "playerInviteTooltip": "Invite",
    "playerInviteA11y": "Invite {name}",
    "playerInviteTitle": "Invite {name}",
    "playerInviteSubtitle": "Share this link with {name} to join this tour.",
    "playerInviteLoadError": "Unable to create an invite link for this player.",
    "playerInviteShareError": "Unable to share invite link.",
    "playerInviteCopied": "Invite link copied to clipboard.",
    "title": "Tour edit",
    "breadcrumbTitle": "Tournament - edit",
    "subtitle": "Web-only editor",
    "backToTours": "Back to tours",
    "tourIdLabel": "Tour ID",
    "tourIdMissing": "Missing tour ID.",
    "webOnlyNote": "This page is available on web only.",
    "nameLabel": "Tour name",
    "namePlaceholder": "Enter tour name",
    "saveCta": "Save",
    "saving": "Saving...",
    "saveSent": "Saving tour...",
    "saveQueued": "Waiting for websocket...",
    "saveAck": "Tour updated.",
    "saveFailed": "Unable to update tour.",
    "saveAll": "Save all",
    "saveAllSent": "Saving all settings...",
    "loading": "Loading tour...",
    "loadError": "Unable to load tour.",
    "nameRequired": "Enter a tour name.",
    "addRound": "Add round",
    "roundNameLabel": "Round name",
    "roundDateLabel": "Play date",
    "roundDateUnset": "Set date",
    "roundDatePicker": "Open calendar",
    "roundDatePickerTitle": "Pick a date",
    "roundDatePickerToday": "Today",
    "roundCreate": "Create round",
    "roundCreateSaving": "Creating...",
    "roundCreateFailed": "Unable to create round.",
    "roundCreateNoPlayers": "No players found for this tournament.",
    "roundCreatePlayerLoading": "Loading players...",
    "addImage": "Add image",
    "uploadingImage": "Uploading image...",
    "imageUploadFailed": "Unable to upload image.",
    "imagePermissionDenied": "Goffy needs access to your photos to set a tour image.",
    "imageUploadSuccess": "Tour image updated.",
    "roundPlayersTitle": "Round players",
    "roundPlayersLoading": "Loading round players...",
    "roundPlayersEmpty": "No players in this round yet.",
    "memberRemoving": "Removing player from tour...",
    "memberRemoveSent": "Removing player from tour...",
    "memberRemoved": "Player removed from tour.",
    "memberRemoveRejected": "Unable to remove player from tour.",
    "memberRemoveTimeout": "Timed out waiting for tour member removal.",
    "roundMemberRemoving": "Removing player from round...",
    "roundMemberRemoveSent": "Removing player from round...",
    "roundMemberRemoved": "Player removed from round.",
    "roundMemberRemoveRejected": "Unable to remove player from round.",
    "roundMemberRemoveTimeout": "Timed out waiting for round member removal.",
    "removeRound": "Remove round",
    "roundRemoving": "Removing round...",
    "roundRemoveSent": "Removing round...",
    "roundRemoved": "Round removed.",
    "roundRemoveRejected": "Unable to remove round.",
    "roundRemoveTimeout": "Timed out waiting for round removal.",
    "roundRemoveBlockedScores": "Round has recorded scores",
    "roundRemoveA11y": "Remove round",
    "roundPlayerRemoveBlockedScores": "Has recorded scores",
    "roundPlayerRemoveBlockedLastPlayer": "Last player in round",
    "roundPlayerRemoveA11y": "Remove player from round",
    "roundPlayerRemoveDisabledA11y": "Player cannot be removed from round",
    "roundAddPlayer": "Add player",
    "roundAddPlayerPlaceholder": "Select tour member",
    "roundAddPlayerNoCandidates": "No available tour members to add.",
    "roundAddPlayerStatusBlocked": "Round status does not allow adding players.",
    "tournamentGamesTitle": "Tournament games",
    "tournamentGamesEmpty": "No tournament-level games selected.",
    "tournamentAddGame": "Add tournament game",
    "tournamentRemoveGame": "Remove",
    "tournamentManagedLabel": "Tournament managed",
    "gameDetailsPanelTitle": "Game details",
    "gameDetailsEmptyState": "Select a game to view details.",
    "gameDetailsScopeLabel": "Scope:",
    "gameDetailsTypeLabel": "Type:",
    "gameScopeLibrary": "Library",
    "gameScopeTournament": "Tournament",
    "gameScopeRoundLocal": "Round-local",
    "cancelRound": "Cancel",
    "done": "Done",
    "playerSearchNoResults": "No players found."
  },
  "auth": {
    "loginTitle": "Log in",
    "loginCardTitle": "Welcome back",
    "loginCta": "Login",
    "loggingIn": "Signing in...",
    "loginSubtitle": "Sign in",
    "loginHint": "You will be redirected to login page.",
    "debugLabel": "Signed in",
    "debugNone": "None",
    "callbackLoading": "Completing sign in...",
    "callbackReady": "Waiting for Keycloak response",
    "continueWithGoogle": "Continue with Google",
    "orDivider": "or"
  },
  "register": {
    "title": "Create account",
    "cardTitle": "Create your account",
    "usernameLabel": "Username",
    "usernamePlaceholder": "yourusername",
    "displayNameLabel": "Display name",
    "displayNamePlaceholder": "Your nickname",
    "emailLabel": "Email",
    "emailPlaceholder": "name@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "At least 6 characters",
    "creating": "Creating...",
    "createCta": "Create account",
    "connectionLabel": "BFF connection: {status}",
    "connectionUp": "active",
    "connectionDown": "disconnected",
    "backToLogin": "Back to start",
    "statusQueued": "Sending request...",
    "statusSuccess": "Account created! Log in with your email and password.",
    "validationMissing": "Enter email, display name, and password.",
    "validationPasswordTooShort": "Password must be at least {min} characters.",
    "connectionMissing": "No connection to BFF. Try again.",
    "createTimeout": "Create request timed out. Please try again.",
    "userExists": "A user with that email already exists.",
    "createFailed": "Failed to create user.",
    "openTermsCta": "Service conditions",
    "openPrivacyCta": "Privacy policy",
    "claimAdoptNotice": "You're creating an account for {name}. Your scores so far will be kept.",
    "claimProofInvalid": "Could not verify your claimed player. Open the invite link and claim your player again.",
    "statusReconnecting": "Connection lost — still finishing your registration...",
    "termsNotice": "By creating an account you accept our service conditions and privacy policy.",
    "loginInsteadCta": "Log in instead",
    "emailSuggestion": "Did you mean {email}?",
    "emailSuggestionApply": "Use this address",
    "emailSuggestionDismiss": "Keep what I typed"
  },
  "login": {
    "userNotFound": "Your user no longer exists. Please sign in again."
  },
  "start": {
    "title": "Welcome to Goffy",
    "subtitle": "Enter an invite code if you have one, or continue with a new or existing account.",
    "roundCodeLabel": "Invite code",
    "roundCodePlaceholder": "Enter invite code",
    "roundCodeRequired": "Enter an invite code to continue.",
    "roundCodeInvalid": "That invite code could not be found.",
    "roundCodeLookupFailed": "Failed to open that invite code. Try again.",
    "joinWithCodeCta": "Join with code",
    "scanQrCta": "Scan QR code",
    "qrScanTitle": "Scan invite QR code",
    "qrScanSubtitle": "Point the camera at the QR code from the tour or round invite.",
    "qrScanCancelCta": "Cancel",
    "qrScanGrantCta": "Allow camera",
    "qrScanPermissionPrompt": "Goffy needs the camera to read the invite QR code.",
    "qrScanPermissionDenied": "Camera access was denied, so the QR code cannot be read.",
    "qrScanPermissionBlocked": "Camera access is blocked. Allow the camera for Goffy in your device or browser settings, then try again.",
    "qrScanUnrecognized": "That QR code is not a Goffy invite.",
    "qrScanFriendInvite": "That is a friend invite. Log in first, then scan it again.",
    "resumeClaimTitle": "Continue as {name}",
    "resumeClaimBody": "You are still scoring in {tour} on this device. No login needed.",
    "resumeClaimCta": "Continue scoring",
    "resumeClaimLeaderboardCta": "Open tour leaderboard",
    "resumeClaimFallbackName": "your player",
    "resumeClaimFallbackTour": "this tour",
    "signUpCta": "Sign up",
    "logInCta": "Log in",
    "emailLabel": "Email",
    "emailPlaceholder": "you@example.com",
    "passwordLabel": "Password",
    "passwordPlaceholder": "Enter password",
    "orDivider": "or",
    "googleCta": "Continue with Google",
    "forgotPasswordCta": "Forgot password?",
    "credentialsRequired": "Enter your email and password.",
    "loginFailed": "Incorrect email or password."
  },
  "welcome": {
    "title": "Welcome",
    "body": "Choose how you want to start: create a single round, start a new tour, or open your existing tours and unfinished rounds.",
    "startSingleRound": "Start single round",
    "startQuickRound": "Quick round",
    "startTour": "Create tour",
    "myTours": "My tours and rounds",
    "myToursOpenSummary": "Tours: {tours}  Rounds: {singleRounds}",
    "myToursNav": "Tour & Rounds"
  },
  "quickRound": {
    "trackingTitle": "Track"
  },
  "friendInvite": {
    "title": "Connect as friends",
    "showTitle": "Let them scan this",
    "showSubtitle": "Point the other phone's camera at the code",
    "expiryNote": "The code refreshes every couple of minutes",
    "shareAction": "Share link",
    "shareError": "Could not share the link.",
    "loadError": "Could not create an invite code.",
    "regenerate": "New code",
    "close": "Close",
    "previewTitle": "{name} wants to connect",
    "previewUnknown": "Someone wants to connect on Goffy",
    "signInToConnect": "Sign in to connect",
    "connecting": "Connecting...",
    "connected": "You and {name} are now friends",
    "alreadyConnected": "You are already friends with {name}",
    "seeFriends": "See my friends",
    "errorExpired": "This code has expired. Ask them to show a new one.",
    "errorInvalid": "This invite link is not valid.",
    "errorSelf": "That is your own invite code.",
    "errorPlayerRequired": "This account cannot be added as a friend yet.",
    "errorUnauthenticated": "Sign in to connect.",
    "errorFailed": "Could not connect. Try again."
  },
  "friends": {
    "connectViaQr": "Connect via QR",
    "title": "Friends",
    "loading": "Loading friends...",
    "empty": "No friends added yet.",
    "myFriends": "My friends",
    "linked": "Friend",
    "addLinked": "Add a friend",
    "searchPlaceholder": "Search by name or Golf ID",
    "add": "Add",
    "remove": "Remove",
    "editNickname": "Edit nickname",
    "cancel": "Cancel",
    "nicknamePlaceholder": "Nickname (optional)",
    "saveNickname": "Save nickname",
    "actionFailed": "Unable to update friends.",
    "findPlayersPlaceholder": "Find players...",
    "filterAll": "All",
    "filterLinked": "Friends",
    "filterGuests": "My guests",
    "guest": "Guest",
    "countAll": "Players {count}",
    "countLinked": "Friends {count}",
    "countGuests": "My guests {count}",
    "guestsEmpty": "No guest players added yet.",
    "guestsFailed": "Unable to load your guest players.",
    "noMatches": "No friends match your search.",
    "searchHint": "Type a name, or an exact Golf ID to find players who are only findable that way.",
    "searchNoResults": "No players match your search.",
    "searchFailed": "Unable to search players.",
    "searching": "Searching..."
  },
  "debug": {
    "deeplinkTitle": "Deep link debug",
    "deeplinkPlatform": "Platform",
    "deeplinkLatest": "Latest URL",
    "deeplinkEmpty": "No deep link received yet.",
    "button": "Debug",
    "buttonLabel": "Debug information",
    "title": "Debug info",
    "userLabel": "User",
    "userIdLabel": "User ID",
    "playerIdLabel": "Player ID",
    "roundLabel": "Round ID",
    "roundNameLabel": "Round name",
    "tourLabel": "Tour ID",
    "tourNameLabel": "Tour name",
    "holeViewTraceLabel": "Hole view traceId",
    "holeScoreTraceLabel": "Hole score traceId",
    "traceNone": "None",
    "copyIdsLabel": "Copy debug ids",
    "copyIdLabel": "Copy {label}",
    "loading": "Loading names...",
    "unknown": "Unknown",
    "close": "Close",
    "disable": "Disable debug",
    "resetCoachMarks": "Reset coach marks",
    "resetCoachMarksRunning": "Resetting coach marks...",
    "resetCoachMarksSuccess": "Coach marks reset for this user.",
    "resetCoachMarksError": "Unable to reset coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "No coach marks loaded.",
    "coachMarkLabel": "Coach mark: {key}",
    "coachMarkDismissed": "hidden"
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Create your first tour",
    "tournamentsCreateBody": "Add or create players then select New tour button to create a new tour and continue to round setup.",
    "profileImageActionsTitle": "Set your profile image",
    "profileImageActionsBody": "Upload an image or select an avatar to show together with your name.",
    "holeScoreTitle": "Score row tips",
    "holeScoreBody": "Tap Score to open score entry and register hazards or mystery game outcomes.",
    "gotIt": "Got it",
    "hideForever": "Don't show this tip again",
    "disableAll": "Turn off all coach tips"
  },
  "menu": {
    "adminTools": "Admin tools",
    "profile": "Profile",
    "statistics": "Statistics",
    "about": "Service status",
    "aboutTitle": "Service status",
    "aboutLoading": "Loading status...",
    "aboutEmpty": "No status data available.",
    "aboutError": "Error:",
    "aboutLoadError": "Unable to load status.",
    "aboutUnknownService": "Unknown service",
    "aboutUnknownImage": "Unknown image",
    "viewAs": "View as…",
    "viewAsActive": "View as: {role}",
    "viewAsTitle": "View app as role",
    "viewAsHint": "Display only — the server still enforces your real roles.",
    "viewAsDeveloper": "Developer",
    "viewAsAdmin": "Admin",
    "viewAsPaidUser": "Paid user",
    "viewAsUser": "User",
    "viewAsPlayer": "Player (no roles)",
    "viewAsReset": "Reset to my real roles",
    "home": "Home",
    "friends": "Friends",
    "hole": "Hole",
    "selectGames": "Select game",
    "tour": "Tour",
    "tourSettings": "Tour settings",
    "tourLeaderboard": "Tour leaderboard",
    "golfCourses": "Golf courses",
    "gameCalculator": "Game Calculator",
    "golfGamesAdmin": "Golf Games Admin",
    "configCourse": "Config course",
    "scoreAllHoles": "Score all holes (debug)",
    "scoreAllHolesRunning": "Scoring all holes…",
    "scoreAllHolesDone": "Entered {scores} scores across {holes} holes for {players} players. Events: {events}, mystery: {mystery}.",
    "scoreAllHolesError": "Could not score all holes.",
    "roundInfo": "Round information",
    "roundInfoLoading": "Loading round information…",
    "roundInfoError": "Could not load round information.",
    "roundInfoCopy": "Copy",
    "scoreAllHolesCountLabel": "How many holes to score?",
    "scoreAllHolesStart": "Score",
    "scoreAllHolesImport": "Import file…",
    "scoreAllHolesClean": "Clear existing players & scores before import",
    "scoreAllHolesImportHint": "Import file: create it with tools/game-calculator/fetch-round-scores.py export <ROUND_ID> (prod DB via ./scripts/open_ports_ssm.py). Players are matched by name, games and scores are replayed onto this round.",
    "scoreAllHolesImportError": "Unable to import round file.",
    "scoreAllHolesHole": "Hole {hole} (par {par})",
    "scoreAllHolesRow": "{name}: {strokes}",
    "scoreAllHolesMystery": "Mystery winners",
    "scoreAllHolesMysteryRow": "Hole {hole}: {name}",
    "ok": "OK",
    "roundResults": "Round",
    "scorecard": "Scorecard",
    "holeView": "View",
    "more": "Menu",
    "back": "<- Back",
    "logout": "Log out",
    "close": "Close",
    "anonymous": "Guest",
    "privacy": "Privacy policy",
    "courseMapping": "Course mapping",
    "courseMappingReview": "Review course mapping",
    "manageSubscription": "Manage subscription",
    "paymentsAdmin": "Payments & subscriptions",
    "golfCourseAdmin": "Golf course admin",
    "terms": "Service conditions",
    "appInfo": "About",
    "reportBug": "Report bug",
    "reportBugTitle": "Report bug",
    "reportBugHint": "Describe what happened. Include expected vs actual behavior.",
    "reportBugDescriptionPlaceholder": "What happened? What did you expect?",
    "reportBugAddImage": "Add image",
    "reportBugRemoveImage": "Remove image",
    "reportBugPasteHint": "Tip: paste an image from clipboard while this modal is open.",
    "reportBugSend": "Send report",
    "reportBugSending": "Sending...",
    "reportBugSent": "Bug report sent to Slack #bugs.",
    "reportBugSendFailed": "Unable to send bug report",
    "reportBugInvalidImage": "Only image files are supported.",
    "reportBugImageTooLarge": "Image is too large (max 8 MB).",
    "reportBugMissingContent": "Add a description or image before sending.",
    "reportBugFileUnsupported": "File upload is only supported on web."
  },
  "profile": {
    "title": "Profile",
    "loading": "Loading profile...",
    "loadFailed": "Unable to load profile.",
    "playerProvisioning": "Setting up your player profile...",
    "displayNameLabel": "Display name",
    "displayNamePlaceholder": "Your nickname",
    "fullNameLabel": "Full name",
    "fullNamePlaceholder": "Your full name",
    "nameLabel": "Name",
    "namePlaceholder": "Enter your name",
    "emailLabel": "Email",
    "emailPlaceholder": "name@example.com",
    "genderLabel": "Gender",
    "genderPlaceholder": "male, female, or other",
    "genderMale": "Male",
    "genderFemale": "Female",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "e.g. 12.4",
    "handicapDateLabel": "Handicap date",
    "handicapDatePlaceholder": "YYYY-MM-DD",
    "golfIdLabel": "Golf ID",
    "golfIdPlaceholder": "e.g. 901231-001",
    "golfIdHelp": "Your federation Golf ID. Other players can find you by it when you allow it below.",
    "invalidGolfId": "Enter a valid Golf ID (letters, digits and hyphens).",
    "golfIdTaken": "That Golf ID is already used by another account.",
    "searchVisibilityLabel": "Who can find me",
    "searchVisibilityName": "By name",
    "searchVisibilityGolfId": "By Golf ID only",
    "searchVisibilityNever": "Nobody",
    "searchVisibilityNameHelp": "You appear in player lists and in search by name.",
    "searchVisibilityGolfIdHelp": "You are hidden from player lists; only someone who types your exact Golf ID can find you.",
    "searchVisibilityNeverHelp": "You never appear in search or player lists. Friends and people in your tours still see you.",
    "searchVisibilityGolfIdRequired": "Add your Golf ID before choosing to be found by Golf ID only.",
    "imageLabel": "Profile image",
    "uploadImage": "Upload image",
    "selectAvatar": "Select avatar",
    "removeAvatar": "Remove avatar",
    "avatarPickerTitle": "Choose an avatar",
    "avatarMore": "More",
    "avatarLoading": "Loading avatars...",
    "close": "Close",
    "save": "Save",
    "saving": "Saving...",
    "saveSuccess": "Profile saved.",
    "saveFailed": "Unable to save profile.",
    "handicapRequired": "Enter a handicap when a handicap date is set.",
    "handicapDateRequired": "Enter a handicap date when a handicap is set.",
    "invalidHandicap": "Enter a valid handicap value.",
    "invalidHandicapDate": "Enter a valid handicap date (YYYY-MM-DD).",
    "homeClubsLabel": "Home clubs",
    "homeClubsEmpty": "No home clubs selected.",
    "homeClubsAdd": "Add home club",
    "homeClubsPrimary": "Primary",
    "homeClubsSetPrimary": "Set primary",
    "homeClubsRemove": "Remove",
    "homeClubsPickerTitle": "Select home club",
    "homeClubsSearchPlaceholder": "Search clubs...",
    "homeClubsLoading": "Loading clubs...",
    "homeClubsNoResults": "No clubs found.",
    "homeClubsUnknownLocation": "Unknown location",
    "homeClubsRefresh": "Refresh",
    "homeClubsLoadFailed": "Unable to load clubs.",
    "uploading": "Uploading image...",
    "uploadSuccess": "Image uploaded.",
    "uploadFailed": "Unable to upload image.",
    "permissionDenied": "Photo library permission denied.",
    "passwordSectionLabel": "Password",
    "changePassword": "Change password",
    "setPassword": "Set password",
    "passwordSetHint": "You signed in with Google. Set a password to also log in with email and password.",
    "currentPasswordLabel": "Current password",
    "newPasswordLabel": "New password",
    "newPasswordPlaceholder": "At least {min} characters",
    "repeatPasswordLabel": "Repeat new password",
    "passwordMismatch": "Passwords do not match.",
    "passwordTooShort": "Password must be at least {min} characters.",
    "currentPasswordRequired": "Enter your current password.",
    "currentPasswordInvalid": "Current password is incorrect.",
    "passwordAccountLocked": "Too many attempts. Try again later.",
    "passwordChangeFailed": "Unable to change password.",
    "passwordChangeTimeout": "Request timed out. Please try again.",
    "passwordChanged": "Password updated.",
    "passwordSaving": "Updating password...",
    "deleteAccountSectionLabel": "Delete account",
    "deleteAccountHint": "Removes your login and your profile. This cannot be undone.",
    "deleteAccount": "Delete my account",
    "deleteAccountConfirmTitle": "Delete your account?",
    "deleteAccountConfirmBody": "Your login, profile, photo and settings are deleted permanently. You cannot undo this.",
    "deleteAccountConfirmHistory": "Rounds and tours you played stay on the other players' scorecards, still shown against your name. Removing them would rewrite someone else's round.",
    "deleteAccountConfirm": "Delete account",
    "deleteAccountCancel": "Cancel",
    "deleteAccountPending": "Deleting...",
    "deleteAccountFailed": "Unable to delete the account. Please try again.",
    "enhancedInputSectionLabel": "Shot detail",
    "enhancedInputHint": "Record fairways, putts and greens in regulation on your own scores. Nobody else sees them, and nothing else in the round changes.",
    "enhancedInputToggleLabel": "Track shot detail",
    "enhancedInputOn": "On",
    "enhancedInputOff": "Off",
    "shotTrackingSectionLabel": "Automatic shot distances",
    "shotTrackingHint": "Measure how far you hit each shot, hands-free. The phone listens for the strike only while you are standing still and uses GPS for the distance. No audio is ever saved or leaves the phone — only the moment of impact. Works together with the watch when you wear one.",
    "shotTrackingToggleLabel": "Measure my shots",
    "shotTrackingOn": "On",
    "shotTrackingOff": "Off",
    "shotTrackingAndroidOnly": "Phone-based detection currently works on Android. On other devices the watch can still mark your shots.",
    "showDistanceSectionLabel": "Distance to green",
    "showDistanceHint": "Show your live distance to the middle of the green next to Par and Index on the hole screen. Uses your phone's GPS.",
    "showDistanceToggleLabel": "Show distance",
    "showDistanceOn": "On",
    "showDistanceOff": "Off",
    "coachTipsSectionLabel": "Coach tips",
    "coachTipsHint": "Coach tips point out features while you play. They keep showing until you hide them.",
    "coachTipsToggleLabel": "Show coach tips",
    "coachTipsOn": "On",
    "coachTipsOff": "Off",
    "coachTipsReset": "Show hidden tips again",
    "coachTipsResetting": "Restoring tips...",
    "coachTipsSaveFailed": "Could not update coach tips.",
    "distanceUnitSectionLabel": "Distances",
    "distanceUnitHint": "How distances are shown throughout the app. Everything is stored in metres, so switching only changes what you read.",
    "distanceUnitMetric": "Metres and kilometres",
    "distanceUnitImperial": "Yards and miles",
    "shotTrackingDebugLink": "Shot tracking debug (developers)"
  },
  "statistics": {
    "title": "My statistics",
    "tabGames": "Games & tours",
    "tabScoring": "Scoring",
    "allTime": "All time",
    "loading": "Loading statistics...",
    "loadFailed": "Unable to load your statistics.",
    "noPlayer": "No player profile found for your account yet.",
    "signedOut": "Sign in to see your statistics.",
    "retry": "Try again",
    "emptyTitle": "No rounds yet",
    "emptyHint": "Play and score a round, and your statistics will start building up here.",
    "roundsPlayed": "Rounds played",
    "tours": "Tours",
    "activeSuffix": "· {count} active",
    "gamesPlayed": "Games played",
    "meritsEarned": "Merits earned",
    "vsLastSeason": "{delta} vs last season",
    "sameAsLastSeason": "Same as last season",
    "activeTours": "Active tours",
    "noActiveTours": "No tours running right now.",
    "tourLeading": "of {players} players · leading",
    "tourBehind": "of {players} players · {merits} merits behind",
    "trophyCabinet": "Trophy cabinet",
    "trophyCabinetNote": "All time, whichever period is selected.",
    "tourWins": "Tour wins",
    "tourRunnerUps": "Runner-up",
    "tourPodiums": "Podiums",
    "roundWins": "Round wins",
    "gamesPlayedAndWon": "Games — played and won",
    "noGames": "No games played in this period.",
    "gameWinsOfRounds": "{wins} of {rounds}",
    "unknownGame": "Game",
    "recentRounds": "Recent rounds",
    "noRounds": "No rounds in this period.",
    "roundScore": "{gross} · {toPar}",
    "positionOf": "{position} of {total}",
    "averageToPar": "Avg vs par · per 18",
    "bestRound": "Best round",
    "bestRoundAt": "Best round · {course}, {date}",
    "playingHandicap": "Playing handicap",
    "playingHandicapNote": "The playing handicap stamped on each round, oldest to newest.",
    "handicapDown": "▼ {delta} this period",
    "handicapUp": "▲ {delta} this period",
    "formTitle": "Form — score to par, last {count} rounds",
    "average": "avg",
    "formLegend": "Shorter is better. Tap a round to open its scorecard.",
    "scoreDistribution": "Scores · {holes} holes",
    "noHoles": "No scored holes in this period.",
    "eagle": "Eagle",
    "birdie": "Birdie",
    "par": "Par",
    "bogey": "Bogey",
    "doublePlus": "Double+",
    "countWithShare": "{count} · {share}%",
    "pickupsExcluded": "{count} picked-up holes are not counted.",
    "averageOverPar": "Average over par",
    "parN": "Par {par}",
    "frontNine": "Front 9",
    "backNine": "Back 9",
    "shotDetail": "Shot detail",
    "fairwaysHit": "Fairways hit",
    "greensInRegulation": "Greens in regulation",
    "puttsPerRound": "Putts per round",
    "puttsPerGir": "Putts per green hit",
    "shotDetailOfHoles": "{part} of {total} holes",
    "shotDetailPuttsHint": "{perHole} per hole over {holes} holes",
    "recordsAndStreaks": "Records & streaks",
    "mostBirdies": "Most birdies in a round",
    "longestStreak": "Longest par-or-better streak",
    "holesCount": "{count} holes",
    "bestComeback": "Best back nine vs front nine",
    "holeInOnes": "Hole in one",
    "nemesisHole": "Nemesis hole",
    "nemesisValue": "#{hole} {course}",
    "nemesisHint": "{average} avg over {plays} plays"
  },
  "teamDraw": {
    "title": "Team draw"
  },
  "serviceStatus": {
    "buttonLabel": "Service status",
    "alert": "!",
    "title": "Services unavailable",
    "allOk": "All services are running.",
    "warningsFound": "Warnings or errors detected in logs.",
    "host": "Host: {host}",
    "httpCode": "Return code: {code}",
    "unknownHost": "Unknown host",
    "envVar": "Env var: {envVar}",
    "unknownEnvVar": "Env var: unknown",
    "ipAddress": "Resolved IP: {ip}",
    "unknownTimestamp": "Unknown timestamp",
    "unknownService": "Unknown service",
    "unknownBody": "No log body",
    "continueMissing": "Continue (missing: {missing})",
    "close": "Close",
    "checkedAt": "Checked: {time}",
    "bffName": "backend-for-frontend-service"
  },
  "courseConfig": {
    "title": "Configure course",
    "manageSelectorLabel": "Course to manage",
    "manageCreateNew": "New course",
    "manageSelectedCourse": "Selected course",
    "manageNoCourses": "No courses to manage yet",
    "manageSearchPlaceholder": "Search course, club or city",
    "manageNoMatches": "No course matches \"{query}\"",
    "clubLabel": "Club",
    "clubPlaceholder": "Club name",
    "cityLabel": "City",
    "cityPlaceholder": "City name",
    "coordinatesLabel": "Coordinates",
    "courseLabel": "Course",
    "coursePlaceholder": "Course name",
    "scanButton": "AI Scan scorecard",
    "cameraCapture": "Capture",
    "cameraCancel": "Cancel",
    "cameraUnavailable": "Could not open the camera. Check camera permissions and try again.",
    "scanRunning": "AI is reading the scorecard…",
    "scanThinkingHint": "Analyzing the photo — this can take up to a minute.",
    "scanSuccess": "Scorecard read — please review the values.",
    "scanFailed": "Could not read the scorecard. Enter the holes manually.",
    "scanNotConfigured": "Scorecard scanning isn't configured on the server yet.",
    "scanPermissionDenied": "Camera permission is required to scan.",
    "holeHeader": "Hole",
    "parHeader": "Par",
    "strokeIndexHeader": "Stroke Index",
    "teesTitle": "Tee setup",
    "addTeeButton": "Add tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Remove",
    "teeNameLabel": "Tee name",
    "teeNamePlaceholder": "Yellow",
    "teeGenderLabel": "Gender",
    "genderMale": "Male",
    "genderFemale": "Female",
    "genderUnisex": "Unisex",
    "teeColorLabel": "Tee color",
    "teeColorPlaceholder": "yellow",
    "teeParLabel": "Tee par",
    "makeOfficialLabel": "Add to official courses",
    "makeOfficialHint": "Official courses are shared with everyone. Leave unchecked to keep this course private to you.",
    "disableCourseLabel": "Disable this course",
    "disableCourseHint": "A disabled course is hidden from every course picker but not deleted. Uncheck and save to restore it.",
    "visibilityLabel": "Visibility",
    "visibility_official": "Official",
    "visibility_private": "Private",
    "visibility_pending": "Pending",
    "visibilityHint_official": "Shared with everyone.",
    "visibilityHint_private": "Visible only to you and players you share it with.",
    "visibilityHint_pending": "Submitted for approval; visible only to you until approved.",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Cancel",
    "saveButton": "Save course",
    "saving": "Saving course...",
    "waitingConnection": "Waiting for websocket connection...",
    "saveSuccess": "Course saved {id}",
    "saveRejected": "Unable to save course.",
    "clubRequired": "Club name is required.",
    "courseRequired": "Course name is required.",
    "invalidPar": "Every hole must have a par value.",
    "invalidStrokeIndex": "Every hole must have a stroke index.",
    "teesRequired": "Add at least one tee.",
    "teeNameRequired": "Every tee must have a name.",
    "teeGenderRequired": "Every tee must have a gender value.",
    "invalidCourseRating": "Every tee must have a valid course rating.",
    "invalidSlopeRating": "Every tee must have a valid slope rating.",
    "invalidTeePar": "Every tee must have a valid par.",
    "fixBeforeSave": "Fix the following before saving:",
    "saveWithErrorsLabel": "Save anyway (with errors)",
    "parSumMismatch": "The sum of all hole pars ({sum}) must equal the Tee par ({teePar}).",
    "strokeIndexDuplicate": "Stroke index {value} is used by more than one hole (holes {holes}). Each stroke index may be used only once.",
    "strokeIndexRange": "Stroke index must be a number between 1 and 18 (hole {hole} has {value}).",
    "lengthHeader": "Length (m)",
    "invalidLength": "Hole length must be a positive number, or left blank if unknown.",
    "osmButton": "Import data from OpenStreetMap",
    "osmSearching": "Searching…",
    "osmImporting": "Importing holes…",
    "osmUnnamed": "Unnamed course",
    "osmSuccess": "Imported {count} holes — please review the values.",
    "osmPartial": "Imported. {count} stroke indexes were unreadable in OpenStreetMap, so those were left as they were.",
    "osmNoCourses": "No OpenStreetMap course with any usable data was found.",
    "osmNoHoles": "That course has no holes mapped in OpenStreetMap.",
    "osmNoLocation": "Could not determine a position to search around.",
    "osmFailed": "OpenStreetMap lookup failed. Please try again.",
    "osmAttribution": "Hole data © OpenStreetMap contributors (ODbL)",
    "osmSearch": "Search",
    "osmModeNearby": "Nearby",
    "osmModeName": "By name",
    "osmNamePlaceholder": "Course or club name",
    "osmNameTooShort": "Enter at least three characters to search by name.",
    "osmChooseData": "Choose what to import:",
    "osmCategoryHoles": "Hole information",
    "osmCategoryHolesDetail": "{count} holes with par and stroke index",
    "osmCategoryTees": "Tees",
    "osmCategoryTeesDetail": "{count} named tee boxes",
    "osmCategoryGps": "GPS",
    "osmCategoryGpsDetail": "{greens} green positions, {tees} tee positions",
    "osmCategoryTerrain": "Bunkers, water and fairways",
    "osmCategoryTerrainDetail": "{count} traced outlines — used instead of the ones found in satellite imagery",
    "osmImportAction": "Import",
    "osmBack": "Back",
    "osmImportSummary": "Imported {holes} holes, {tees} tee sets and {positions} positions — please review the values.",
    "osmDistanceMeta": "{distance} m away",
    "osmNothingToImport": "OpenStreetMap has nothing for that course — not even a position.",
    "osmCategoryPosition": "Course position",
    "osmCategoryPositionDetail": "Where the course is. Enough on its own to analyse satellite imagery for greens, bunkers and water.",
    "osmImportSummaryWithPosition": "Imported {holes} holes, {tees} tee sets and {positions} positions, and set the course position — satellite imagery will be analysed shortly.",
    "osmImportSummaryPositionOnly": "Set the course position. OpenStreetMap has no holes, tees or greens for this course, so satellite imagery will be analysed to find them.",
    "osmCategoryGpsApproximate": "{greens} green positions, {tees} tee positions — taken from the hole outlines, accurate to a few metres, one per hole",
    "osmLoadingCounts": "Checking what OpenStreetMap has for this course…",
    "osmCoordinateLine": "{origin} {originCoords} · OSM {osmCoords} · {distance}",
    "osmOriginStored": "Stored",
    "osmOriginDevice": "Device",
    "osmOriginMap": "Picked",
    "osmPositionUseOsm": "OSM position ({distance} away)",
    "osmPositionUsePicked": "My picked position",
    "osmPickLocation": "Pick location on map",
    "osmUsePickedAnyway": "None of these — use the picked position anyway",
    "osmMapUseMyLocation": "Use my current location",
    "osmMapLocateDenied": "Location permission was not granted.",
    "osmMapLocateFailed": "Could not determine the device's location.",
    "osmMapGotoPlaceholder": "Latitude, longitude",
    "osmMapGotoInvalid": "Could not read that as a latitude and longitude. Try \"56.6776, 12.8578\".",
    "osmMapGo": "Go",
    "osmMapConfirm": "Search from here",
    "osmMapUseAsPosition": "OSM has nothing here — use this exact position",
    "osmMapCancel": "Cancel",
    "osmMapHint": "Drag the map so the crosshair sits over the course, then confirm.",
    "osmMapPlacePlaceholder": "Search for a place",
    "osmMapPlaceTooShort": "Type at least 3 characters.",
    "osmMapPlaceFailed": "Place search failed.",
    "osmMapPlaceNoResults": "No places found.",
    "osmDebugToggle": "Debug · {count} logged",
    "osmDebugEmpty": "Nothing logged yet.",
    "osmDebugCurlHint": "Commands use $GOFFY_TOKEN — export your bearer token before running them.",
    "osmDebugCopy": "Copy command",
    "osmHolesUnnumbered": "OpenStreetMap has {drawn} hole outline(s) for that course, but {unnumbered} of them carry no hole number — the import needs a numbered hole (the OSM tag ref=1…18) to know which hole is which.",
    "osmTerrainNoHoles": "Bunkers, water and fairways were not imported: OpenStreetMap has no numbered hole outlines for this course to attribute them to."
  },
  "home": {
    "title": "Add players",
    "playerLabel": "Player {index}",
    "namePlaceholder": "Select player",
    "addPlayers": "+ Add players",
    "maxPlayers": "Max 8 players",
    "primaryCta": "Select games",
    "saving": "Saving...",
    "validationRequired": "Please enter at least one player.",
    "scpRequired": "Enter a handicap for all players.",
    "saveError": "Unable to save players.",
    "scpPlaceholder": "SCP"
  },
  "players": {
    "title": "Players",
    "roundInitTitle": "New Round",
    "empty": "No players yet.",
    "addedAt": "Added: {date}",
    "wsError": "WebSocket connection failed.",
    "serviceError": "Players service error",
    "loadError": "Unable to load players.",
    "tourId": "Tour ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Active rounds",
    "activeRoundsRefresh": "Refresh",
    "activeRoundsEmpty": "No active rounds found.",
    "roundsLoadError": "Unable to load rounds.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Open",
    "roundContinue": "Continue",
    "roundFallbackName": "Course",
    "finishedRoundsTitle": "Finished rounds",
    "roundResults": "Results",
    "roundMenuLabel": "Round actions",
    "roundMenuPause": "Pause",
    "roundMenuFinish": "Finish",
    "roundMenuCancel": "Cancel",
    "roundNamePlaceholder": "Round name",
    "roundDescriptionTitle": "Round description",
    "roundDescriptionPlaceholder": "Add a description...",
    "roundDescriptionButton": "Edit round description",
    "playDateLabel": "Play date",
    "playDateQuick": "Quick dates",
    "playDateToday": "Today",
    "holesCountLabel": "Holes",
    "courseLabel": "Course",
    "courseSearchPlaceholder": "Search course",
    "courseSearchEmpty": "No courses found.",
    "addCourse": "Add course",
    "holesCountOptionLabel": "{count} holes",
    "holesCountOptionValue": "{count} holes",
    "teeLabel": "Tee",
    "teeNone": "None",
    "addTee": "Add tee",
    "addTeeTitle": "Add tee",
    "addTeeNameLabel": "Name",
    "addTeeNamePlaceholder": "Tee name",
    "addTeeCourseRatingLabel": "Course rating (optional)",
    "addTeeSlopeRatingLabel": "Slope rating (optional)",
    "addTeeSave": "Add tee",
    "addTeeNameRequired": "Tee name is required.",
    "addTeeNeedsCourse": "Select a course first.",
    "addTeeFailed": "Could not add tee. Please try again.",
    "addTemporary": "Add temporary player",
    "temporaryNamePlaceholder": "Temporary player name",
    "temporaryCreateAction": "Create player",
    "temporaryNameRequired": "Enter a temporary player name.",
    "temporaryCreateFailed": "Unable to create temporary player.",
    "temporaryCreatePending": "Wait for temporary players to be created before starting the round.",
    "temporaryCreatePendingCount": "Creating temporary players: {count}",
    "inviteOthers": "Invite Others",
    "joinWithCode": "Join with code",
    "showQr": "Show QR",
    "selectFromMembership": "Select players from the tour member list.",
    "membersUpdateTimeout": "No confirmation for tour membership update.",
    "membersUpdateSendFailed": "Unable to send tour membership update.",
    "roundInitiateSendFailed": "Unable to start the round.",
    "roundInitiateTimeout": "Round start timed out.",
    "roundInitiateRejected": "Round start was rejected.",
    "missingTour": "Tour is missing, cannot save players.",
    "singleRoundHiddenTourName": "Single round",
    "hiddenTourInitiateFailed": "Unable to start single round right now.",
    "recentlyPlayedTitle": "Recently played",
    "recentlyPlayedSubtitle": "Your last rounds",
    "searchAnyCourseHint": "Search any club, course or city",
    "lookingForAnother": "Looking for another course?",
    "nearbyCoursesTitle": "Nearby courses",
    "courseOfficialBadge": "Official",
    "coursePrivateBadge": "Private",
    "coursePendingBadge": "Pending"
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Player is already part of this round.",
        "playerNotInTour": "Player must be a member of the tour before joining this round.",
        "statusNotAllowed": "Players can only be added when round status is draft, active, or playing.",
        "roundNotFound": "Round could not be found.",
        "invalid": "Round member add request is invalid."
      },
      "remove": {
        "invalid": "Round member removal request is invalid.",
        "invalidPlayer": "Round member removal requires a valid player.",
        "roundNotFound": "Round could not be found.",
        "notMember": "Player is not part of this round.",
        "lastPlayer": "A round must keep at least one player.",
        "hasScores": "Player cannot be removed from this round after scores are recorded."
      }
    },
    "remove": {
      "invalid": "Round removal request is invalid.",
      "roundNotFound": "Round could not be found.",
      "hasScores": "Round cannot be removed after scores are recorded."
    },
    "initiate": {
      "membershipRequired": "All round players must be members of the tour."
    }
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Tour member claim request is invalid.",
        "unauthorized": "Sign in to claim this player.",
        "tourNotFound": "Tour could not be found.",
        "sourceNotFound": "Player could not be found.",
        "sourceNotMember": "Player is not part of this tour.",
        "sourceNotUnclaimed": "Player is already claimed.",
        "targetMissing": "Create your player profile before claiming this player.",
        "targetAlreadyInTour": "Your player is already part of this tour.",
        "targetAlreadyInRound": "Your player is already in one or more rounds in this tour.",
        "mergeConflict": "Claim could not be completed because round data conflicts with your existing player."
      },
      "remove": {
        "invalid": "Tour member removal request is invalid.",
        "invalidPlayer": "Tour member removal requires a valid player.",
        "tourNotFound": "Tour could not be found.",
        "notMember": "Player is not part of this tour.",
        "creatorProtected": "The tour creator cannot be removed.",
        "lastMember": "A tour must keep at least one member.",
        "roundLastPlayer": "Player cannot be removed because one round would become empty.",
        "hasScores": "Player cannot be removed from this tour after scores are recorded."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Create your player profile before creating a tour.",
      "invalidPlayers": "One or more selected players could not be found.",
      "maxPlayersExceeded": "A tour can have at most 8 players."
    }
  },
  "roundResults": {
    "title": "Round results",
    "backToHole": "<- Round result",
    "missingRound": "Select a round to see results.",
    "goPlayers": "Go to players",
    "loadError": "Unable to load round results.",
    "empty": "No results yet.",
    "player": "Name",
    "total": "Tour",
    "gameFallback": "Game",
    "unknownPlayer": "Player",
    "roundFallback": "Round",
    "status": "Status: {status}"
  },
  "mysteryPrize": {
    "title": "Mystery prize",
    "subtitle": "Choose a hole and a subgame for each player.",
    "loading": "Loading mystery setup...",
    "loadError": "Unable to load mystery prize data.",
    "validationError": "Select a hole and subgame for every player.",
    "noPlayers": "No players found for this round.",
    "noSubgames": "No subgames available.",
    "holeLabel": "Hole",
    "subgameLabel": "Subgame",
    "selectHole": "Select hole",
    "selectSubgame": "Select subgame",
    "save": "Save mystery setup",
    "skip": "Skip mystery prize setup",
    "saving": "Saving...",
    "holePickerTitle": "Select hole",
    "subgamePickerTitle": "Select subgame",
    "holeTaken": "Taken"
  },
  "qr": {
    "title": "Scan to open the link",
    "subtitle": "Or tap below to open it directly",
    "fallbackError": "Using fallback link because backend is unavailable."
  },
  "selectGames": {
    "title": "Select games",
    "waiting": "Waiting for tour ID...",
    "tourIdLabel": "Current tour ID",
    "tourLabel": "Tour",
    "roundLabel": "Round",
    "playersLabel": "Players: {count}",
    "gamesLabel": "Games: {count}",
    "missing": "missing",
    "hint": "Keep this screen open until the tour is ready.",
    "quickRoundPreparing": "Setting up your quick round...",
    "quickRoundError": "Could not start the round.",
    "gameListTitle": "Choose a game",
    "recommendedBadge": "Recommended",
    "gameInfo": "Info",
    "gameDescription": "Description",
    "infoIcon": "i",
    "infoVideoTitle": "Mystery game info",
    "infoVideoTitleByGame": "{name} game info",
    "gameNameFallback": "Game",
    "copyFromRound": "Copy from a previous round",
    "copyFromRoundTitle": "Copy from a previous round",
    "copyFromRoundSubtitle": "Takes the games and weights. You can change everything afterwards.",
    "copyFromRoundEmpty": "None of your earlier rounds have games to copy yet.",
    "copyFromRoundClose": "Close",
    "infoDescriptionTitle": "Description",
    "infoDescriptionEmpty": "No description available.",
    "infoDescriptionExtra": "This game is scored hole by hole and contributes to the total round result based on its weight.",
    "infoGameTypeTitle": "Game type",
    "infoGameTypeDefault": "Points-based side game",
    "infoWeightTitle": "Weight setting",
    "infoWeightValue": "Current weight: {weight}%",
    "infoWeightHelp": "Weight controls how much this game affects total merits. 100% gives full impact, lower values reduce impact.",
    "closeVideo": "Close",
    "gameLoadError": "Failed to load games",
    "gameStartError": "Failed to start game",
    "startGame": "Start game(s)",
    "startRound": "Start round",
    "updateCta": "Save and continue",
    "tournamentManagedLocked": "Tournament managed",
    "meritsLabel": "merits",
    "meritsPerTeamLabel": "merits per team",
    "meritsPerAchievementLabel": "merits per achievement",
    "meritsPerEventLabel": "merits per event",
    "meritDistributionTitle": "Merit distribution",
    "meritDistributionTotal": "{merits} merits to win",
    "meritDistributionTotalTour": "{merits} merits to win over {rounds} rounds",
    "meritWeightSetByTour": "Set by tour",
    "meritLadderA11y": "Merits per placement for {name}: {ladder}, weight {weight}%",
    "rulesButton": "Rules",
    "rulesSectionTitle": "Rules",
    "rulesTitle": "{name} rules",
    "rulesSubtitleRound": "Pick the rule set used for this round.",
    "rulesSubtitleTour": "Pick the rule set new rounds in this tour start with.",
    "rulesBack": "Back",
    "rulesClose": "Close",
    "rulesDefaultBadge": "Default",
    "rulesTourDefaultBadge": "Tour default",
    "rulesEmpty": "This game has one set of rules.",
    "rulesReadOnlyHint": "Set by the tour.",
    "rulesNoDescription": "No description available.",
    "rulesA11ySelect": "Use rule set {name}",
    "rulesTileLabel": "Rules: {name}"
  },
  "roundStartSetup": {
    "title": "Round settings",
    "subtitleNamed": "Configure players and games for {name}",
    "subtitleFallback": "Configure players and games for this round",
    "loading": "Loading round setup...",
    "loadError": "Unable to load round setup.",
    "playersTitle": "Round players",
    "playersEmpty": "No players assigned to this round.",
    "playingHandicapLabel": "Playing hcp",
    "playingHandicapPlaceholder": "Handicap",
    "addHandicap": "Add handicap",
    "editPlayer": "Edit player",
    "playerNameLabel": "Name",
    "handicapHelp": "The player's course handicap for this round (-10 to 54).",
    "saveHandicap": "Save",
    "newPlayer": "New player",
    "pickFriend": "or pick a friend",
    "searchFriends": "Search friends…",
    "addedPlayers": "Added",
    "hcpSourcePlayer": "Player's handicap from their last round here",
    "hcpSourceCalculated": "Calculated playing HCP for the selected tee",
    "hcpSourceDefault": "Default — adjust to the player's handicap",
    "hcpSourceProfile": "Player's handicap from their profile — adjust for the course",
    "groupsTitle": "Groups and teams",
    "groupsHint": "Drag a player onto a teammate's card to join their team, onto another group to swap, or tap two cards to swap places.",
    "groupsLocked": "Groups are locked after the round leaves draft status.",
    "groupsEmpty": "No group layout available.",
    "groupsUneven": "Teams are uneven — even them out before the groups can be saved or the round started.",
    "groupsNewTeamHint": "Drop here to start a new team",
    "groupLabel": "Group {index}",
    "teamLabel": "Team {index}",
    "groupsUpdateSending": "Saving group swap...",
    "groupsUpdateSaved": "Groups updated.",
    "groupsUpdateQueued": "Group swap queued until websocket reconnects.",
    "groupsUpdateRejected": "Unable to update groups.",
    "groupsUpdateSendFailed": "Unable to send group swap update.",
    "groupsUpdateTimeout": "Group swap confirmation timed out.",
    "gamesTitle": "Round games",
    "gamesEmpty": "No games assigned to this round.",
    "addMoreGamesCta": "Change games",
    "removePlayerCta": "Remove",
    "removingPlayer": "Removing player...",
    "removeQueued": "Player remove queued.",
    "removeSent": "Player removed.",
    "removeRejected": "Unable to remove player from round.",
    "disableGameCta": "Disable",
    "enableGameCta": "Enable",
    "gamesUpdateQueued": "Round update queued.",
    "gamesUpdateSent": "Round games updated.",
    "updateCta": "Update",
    "openRoundCta": "Open round",
    "openRoundSending": "Opening round...",
    "openRoundQueued": "Round status update queued.",
    "openRoundConfirmed": "Round is now active.",
    "openRoundSendFailed": "Unable to send round status update.",
    "openRoundTimeout": "Round did not become active in time. Try again."
  },
  "tourLeaderboard": {
    "title": "Tour leaderboard",
    "tourName": "Tour: {name}",
    "roundCount": "Rounds: {count}",
    "overallTitle": "Overall leaderboard",
    "roundsPlayed": "{count} rounds",
    "highlightsTitle": "Highlights",
    "highlightBestRound": "Best round",
    "highlightMostWins": "Most round wins",
    "highlightLatestWinner": "Latest round winner",
    "highlightLead": "Lead margin",
    "perGameTitle": "Results per game",
    "winsCount": "{count} wins",
    "parBetterTitle": "Par or better",
    "albatrossCount": "{count} albatross",
    "eaglesCount": "{count} eagles",
    "birdiesCount": "{count} birdies",
    "parsCount": "{count} pars",
    "points": "{points} merits",
    "gamePoints": "{points} pts",
    "player": "Player",
    "total": "Merits",
    "gameFallback": "Game",
    "roundsTitle": "Rounds",
    "roundSectionsTitle": "Rounds",
    "roundSectionTitle": "Round {round}: {name}",
    "roundMembersEmpty": "No members in this round.",
    "roundRowLabel": "Round",
    "roundFallback": "Round",
    "roundEmpty": "No scores yet.",
    "empty": "No results yet.",
    "missingTour": "No tour selected.",
    "goTours": "Go to tours",
    "loadError": "Unable to load leaderboard.",
    "wsConnecting": "Connecting to live leaderboard...",
    "wsWaitingData": "Connected. Waiting for leaderboard data...",
    "wsRetrying": "Still waiting for leaderboard data (retry {count}).",
    "unknownPlayer": "Unknown player",
    "resultsHeader": "Results",
    "resultsButton": "Graph",
    "resultsTitle": "Tour results",
    "resultsTableTitle": "Results table",
    "resultsClose": "Close",
    "resultsError": "Unable to load results.",
    "resultsTableButton": "Table",
    "downloadCsv": "Download CSV",
    "csvError": "No tour results available to download.",
    "csvUnsupported": "CSV download is only available on web.",
    "roundPoints": "Round merits",
    "claimHeader": "Claim",
    "claimCta": "Claim",
    "claiming": "Claiming...",
    "claimPending": "Claim request sent.",
    "claimSuccess": "Player claimed into your profile.",
    "claimTokenMissing": "Claim succeeded, but temporary access could not be established. Please try again.",
    "claimRejected": "Unable to claim this player.",
    "claimSendError": "Could not send claim request.",
    "claimTimeout": "No reply to the claim request. Check your connection and try again.",
    "claimReleaseCta": "Cancel claim",
    "claimReleaseSendError": "Could not cancel claim.",
    "claimReleased": "Claim cancelled.",
    "waitingForRoundSetupTitle": "Round Setup In Progress",
    "waitingForRoundSetup": "Waiting for round setup to complete. You will be moved to hole 1 automatically.",
    "membersTitle": "Tour members",
    "membersClaimHint": "Claim temporary members here.",
    "membersReadOnlyHint": "Log in to claim temporary members.",
    "unassignedPlayersTitle": "Unassigned players",
    "unassignedPlayersHint": "Choose your player to start scoring.",
    "unassignedPlayersEmpty": "No unassigned players left.",
    "membersEmpty": "No members in this tour.",
    "memberTemporary": "Temporary member",
    "memberClaimed": "Claimed member",
    "eclecticTitle": "Eclectic",
    "eclecticSubtitle": "Best Stableford points per hole across all rounds",
    "eclecticGridHint": "Best points per hole, with the round they came from",
    "freezeTitle": "Eclectic Freeze",
    "freezeSubtitle": "Locked points so far — open holes count in the final round",
    "freezeFinalSubtitle": "Final result: locked points + final round on open holes",
    "freezeFinalRoundSubtitle": "Final round underway: locked points + live points on open holes",
    "freezeMerits": "+{merits} merits",
    "tourGamesHeader": "Tour games",
    "highlightBestParAvg": "Best par {par} average",
    "strokesAvg": "{avg} strokes",
    "freezeLockedCount": "{locked}/{total} locked",
    "freezeLockedAvg": "avg {avg}",
    "freezeGridHint": "Locked {locked} + open {open}",
    "freezeGridHintLocked": "Locked {locked}",
    "freezeStale": "stale",
    "freezeLockCta": "Freeze holes"
  },
  "tourPreview": {
    "title": "Tour preview",
    "loading": "Loading the tour…",
    "loadFailed": "Could not load the tour preview.",
    "retry": "Try again",
    "dateNotSet": "Date not decided",
    "courseNotChosen": "Course not chosen yet",
    "courseNotMapped": "Course map not available yet",
    "playPreview": "Play course preview",
    "holesCount": "{count} holes",
    "holeCaption": "Hole {number}",
    "parShort": "Par {par}",
    "strokeIndexShort": "SI {strokeIndex}",
    "play": "Play",
    "pause": "Pause",
    "previousHole": "Previous",
    "nextHole": "Next"
  },
  "tourPhotos": {
    "title": "Tour photos",
    "openAction": "Photos",
    "count": "{count} photos",
    "filterAll": "All",
    "filterUnassigned": "No round",
    "unnamedRound": "Round",
    "empty": "No photos yet",
    "emptyHint": "Photos you take during a round show up here.",
    "loadError": "Could not load photos.",
    "holeLabel": "Hole {hole}",
    "unknownUploader": "Unknown player",
    "delete": "Delete",
    "deleteConfirm": "Delete this photo for everyone in the tour?",
    "deleteConfirmYes": "Delete photo",
    "cancel": "Cancel",
    "close": "Close",
    "captureAction": "Take photo",
    "pickAction": "Add from library",
    "uploading": "Uploading {count}…",
    "uploadFailed": "A photo could not be uploaded. It is still in your camera roll — try again.",
    "cameraDenied": "Camera access is off. Enable it in your device settings.",
    "libraryDenied": "Photo library access is off. Enable it in your device settings.",
    "tooLarge": "That photo is too large (max 15 MB).",
    "unsupportedType": "Use a JPEG, PNG or WebP photo.",
    "uploadFailedTitle": "Photo not uploaded",
    "setAsTourImage": "Use as tour image",
    "setAsTourImageQueued": "Set as the tour image. It may take a moment to appear.",
    "setAsTourImageFailed": "Could not set the tour image. Try again.",
    "makePublic": "Make public",
    "makePrivate": "Make private",
    "publicNote": "Public — anyone with the link can see this photo.",
    "visibilityFailed": "Could not change who can see the photo. Try again.",
    "shareAction": "Share link",
    "shareCopied": "Link copied.",
    "shareFailed": "Could not share the link."
  },
  "tourInvite": {
    "title": "Invite",
    "courseLabel": "Course",
    "viewerTitle": "Just watching?",
    "viewerHint": "Follow the tour, rounds and live scoring without claiming a player.",
    "viewerCta": "View as spectator"
  },
  "scorecard": {
    "title": "Scorecard",
    "player": "Player",
    "hole": "Hole",
    "par": "Par",
    "index": "Index",
    "strokes": "Strokes",
    "points": "Points",
    "out": "Out",
    "in": "In",
    "total": "Total",
    "totalGross": "Strokes",
    "totalStableford": "Points",
    "selectRoundTitle": "Select a round",
    "selectRoundLoading": "Loading rounds...",
    "selectRoundEmpty": "No rounds available.",
    "selectRound": "Select",
    "selectRoundError": "Unable to load rounds.",
    "selectRoundFallback": "Round",
    "missingRound": "No round selected.",
    "loadError": "Unable to load scorecard."
  },
  "hole": {
    "title": "Hole",
    "holeLabel": "Hole",
    "loading": "Loading hole...",
    "notRoundMember": "You are not a player in this round — live view is unavailable.",
    "scoreButtonLabel": "Score",
    "frozenHoleBadge": "Hole is frozen",
    "frozenHoleBadgePoints": "Hole is frozen at {points} points",
    "unfrozenHoleBadge": "Hole is not frozen",
    "unfrozenHoleBadgePoints": "Hole is not frozen, {points} points to freeze",
    "eclecticBestBadge": "Eclectic best so far {points} points",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicap strokes {value}",
    "scorePopupHandicapAndIndexLabel": "Handicap strokes {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Scoring UI goes here.",
    "roundId": "Round: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Game",
    "playerBreakdownTitle": "Merits for {name}",
    "playerBreakdownEmpty": "No merits available.",
    "positionShort": "Pos {position}",
    "positionShared": "shared",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard (Merits)",
    "roundColumn": "Round",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - round (Tour)",
    "noGamesSelected": "No games selected. Leaderboard is hidden.",
    "unknownPlayer": "Unknown player",
    "gamesTitle": "🏆 Games",
    "mysteryPrizeTitle": "Mystery prize",
    "mysteryPrizeSetup": "Mystery prize",
    "skinsCarry": "💰 Skins: {count} skins at stake on this hole!",
    "skinsCarryNext": "💰 Skins: {count} skins at stake on the next hole!",
    "shotTracker": {
      "lastShot": "🎯 {count} shots · last {distance}",
      "countOnly": "🎯 {count} shots detected",
      "putts": " · {putts} putts"
    },
    "missingRound": "No round selected.",
    "goPlayers": "Go to players",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (winner {winner})",
    "mysteryPrizeNone": "No mystery prize for this hole.",
    "noPlayers": "No players to show.",
    "puttOne": "1 putt",
    "puttTwo": "2 putts",
    "puttThree": "3 putts",
    "puttPlus": "+ putts",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Unknown subgame",
    "mysteryPrizeUnknownPlayer": "Unknown player",
    "mysteryPrizeWinnerTitle": "Select winner",
    "mysteryPrizeWinnerSaveFailed": "Unable to save mystery prize winner.",
    "mysteryPrizeNextHoleTitle": "Mystery prize next hole",
    "mysteryPrizeNextHoleSubtitle": "On hole {hole}, the mystery prizes are selected as:",
    "mysteryPrizeSelectWinner": "Select winner",
    "mysteryPrizeBack": "Back",
    "backButton": "<- Back",
    "showDetails": "Show details",
    "hideDetails": "Hide details",
    "pickup": "Pickup",
    "scoreChangeConfirmTitle": "Change score?",
    "scoreChangeConfirmMessage": "{name} already has {current} on this hole. Change to {next}?",
    "scoreChangeConfirmCta": "Change",
    "scoreChangeConfirmCancel": "Cancel",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "No round state received.",
    "close": "Close",
    "matchDormie": "Dormie in {game}: {team} is {lead} up with {holes} to play",
    "matchWon": "{team} has won {game}: {lead} up with {holes} to play",
    "matchTeamFallback": "Team",
    "leaderboardChangeTitle": "Leaderboard Changed",
    "leaderboardChangeSubtitle": "All scores submitted for Hole {hole}",
    "leaderboardChangeViewLeaderboard": "View Leaderboard",
    "leaderboardChangeContinue": "Continue",
    "netScoreLabel": "Net score",
    "netSummary": "Net {net}{vsPar}",
    "netSummaryEmpty": "Net –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Select hole",
    "menuButton": "Hole {hole}",
    "menuPlayed": "Played",
    "menuNotPlayed": "Not played",
    "menuMyScore": "My score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Current hole",
    "prevHole": "Previous hole",
    "prevHoleSwipeHint": "Swipe again to move to the previous hole.",
    "nextHole": "Next hole",
    "nextHoleSwipeHint": "Swipe again to move to the next hole.",
    "finishRound": "Finish round",
    "finishRoundHint": "Tap to finish the round.",
    "holeViewTitle": "Hole {hole}",
    "holeViewBeta": "Beta",
    "holeViewDisclaimerToggle": "Beta Disclaimer",
    "holeViewBetaNotice": "Beta: positions come from course mapping and your phone's GPS. Distances are estimates and can be wrong — check them before you pick a club.",
    "holeViewDistance": "{distance} from the back tee to the green centre",
    "holeViewElevationUphill": "{change} uphill to the green",
    "holeViewElevationDownhill": "{change} downhill to the green",
    "holeViewElevationLevel": "The green is level with you",
    "holeViewToGreen": "To green centre",
    "holeViewHoleLength": "Hole length",
    "holeViewYou": "You",
    "holeViewTargetHint": "Tap the map to measure to a point",
    "holeViewTargetFromYou": "You to target",
    "holeViewTargetFromTee": "Tee to target",
    "holeViewTargetToGreen": "Target to green",
    "holeViewTargetClear": "Clear",
    "holeViewZoomFit": "Fit",
    "holeViewFlyover": "Flyover",
    "holeViewBasemap_satellite": "Satellite",
    "holeViewBasemap_hazards": "Hazards",
    "holeViewBasemap_drawing": "Drawing",
    "holeViewShapesNotice": "Bunkers, water and greens are detected automatically from satellite imagery and are not reviewed. Check them against what you can see.",
    "holeViewWind_calm": "Calm",
    "holeViewWind_helping": "Helping",
    "holeViewWind_into": "Into",
    "holeViewWind_leftToRight": "Off the left",
    "holeViewWind_rightToLeft": "Off the right",
    "holeViewLocating": "Finding your position…",
    "holeViewOffHole": "You are not on this hole, so the length is measured from the back tee.",
    "holeViewLocationDenied": "Location is off, so the length is measured from the back tee.",
    "holeViewLocationUnavailable": "No position available, so the length is measured from the back tee.",
    "holeViewTee": "Tee",
    "holeViewGreenCentre": "Green centre",
    "holeViewHazardBunker": "Bunker",
    "holeViewHazardWater": "Water",
    "holeViewHazardToggle": "Hazard distances",
    "holeViewUnavailable": "This hole has not been mapped yet. Tee and green positions appear once the course has been mapped.",
    "finishSendFailed": "Unable to finish the round.",
    "eventSendFailed": "Unable to send hole event.",
    "offlinePending": "Offline — {count} saved",
    "offlineSyncing": "Syncing…",
    "offlineSynced": "Synced",
    "offlineSyncFailed": "{count} entries could not be synced",
    "offlineRoundClosed": "The round is finished — reopen it to record",
    "event": {
      "water": "Water",
      "penalty": "Penalty",
      "bunker": "Bunker",
      "threePutt": "3 putts",
      "chipIn": "Chip in",
      "fairway": "Fairway",
      "putts": "Putts",
      "gir": "GIR"
    },
    "enhanced": {
      "unset": "–",
      "fairwayHit": "Hit",
      "fairwayLeft": "Left",
      "fairwayRight": "Right",
      "girHit": "Hit",
      "girMiss": "Miss",
      "fairwayPrevious": "Fairway, previous",
      "fairwayNext": "Fairway, next",
      "puttsDecrease": "One putt fewer",
      "puttsIncrease": "One putt more"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "distanceToGreenBadge": "{distance}",
    "playersLoadFailed": "Could not load players.",
    "holeViewAnalysis": "Data analysis",
    "holeViewReportInaccurate": "Report inaccurate data",
    "holeViewReported": "Thanks — reported",
    "holeViewReanalyze": "Reanalyze course",
    "holeViewReanalyzeRequesting": "Requesting…",
    "holeViewReanalyzeQueued": "Queued for reanalysis",
    "holeViewReanalyzeUnavailable": "Reanalysis is not available"
  },
  "deviceLink": {
    "title": "Sign in",
    "message": "Taking you to sign in…"
  },
  "notFound": {
    "title": "Oops!",
    "message": "This screen doesn't exist.",
    "cta": "Go to home screen!"
  },
  "modal": {
    "title": "Modal"
  },
  "edit": {
    "openCode": "Open up the code for this screen:",
    "autosave": "Change any of the text, save the file, and your app will automatically update.",
    "help": "Tap here if your app doesn't automatically update after making changes"
  },
  "language": {
    "label": "Language",
    "english": "English",
    "swedish": "Swedish",
    "danish": "Danish"
  },
  "course": {
    "label": "Use nearest golf course",
    "enableLocationHint": "(Enable location for this)",
    "refresh": "Refresh",
    "loading": "Finding courses...",
    "none": "No courses found nearby.",
    "permissionDenied": "Location permission denied.",
    "helpLabel": "Location help",
    "helpTitle": "Enable location to use nearest golf course",
    "helpDescription": "Allow location access in your browser or device settings to automatically find nearby courses.",
    "select": "Select a course",
    "error": "Could not load courses.",
    "insecure": "Using a default location (needs HTTPS for precise location)."
  },
  "appError": {
    "title": "Something went wrong",
    "message": "Please reload the page. If this keeps happening, contact support.",
    "retry": "Try Again"
  },
  "gameGroups": {
    "main": "Main games",
    "match": "Match games",
    "team": "Team games",
    "hazard": "Hazard games",
    "achievement": "Achievement games",
    "challenge": "Challenges",
    "other": "Other games",
    "tournament": "Tour games"
  },
  "summary": {
    "title": "Round Summary",
    "missingInfo": "Missing round ID or user token.",
    "loadError": "Failed to load round data.",
    "overallTitle": "Overall leaderboard",
    "playerHeader": "Player",
    "scoreHeader": "Score",
    "gameHeader": "Merits",
    "pointsHeader": "Total Merits",
    "eventsCount": "{count} events",
    "gamesTitle": "Results per game",
    "gamesEmpty": "No game results yet.",
    "hazardsTitle": "Hazard games",
    "hazardsEmpty": "No hazard events recorded.",
    "hazardTotal": "Total {count}",
    "hazardWater": "Water {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-putt {count}",
    "hazardPenalty": "Penalty {count}",
    "pointsValue": "{points} points",
    "meritsValue": "{merits} merits",
    "positionByHoleTitle": "Position by hole",
    "positionByHoleEmpty": "No leaderboard history recorded yet.",
    "strokesValue": "{strokes} strokes",
    "piecesValue": "{pieces}",
    "holesValue": "{holes} holes",
    "skinsValue": "{skins} skins",
    "mysteryTitle": "Mystery game highlights",
    "mysteryEmpty": "No mystery selections found.",
    "mysteryHolePrize": "Hole {hole} - {prize}",
    "mysterySubgame": "Subgame: {subgame}",
    "mysteryWinner": "Winner: {winner}",
    "mysteryPrizeFallback": "Mystery prize",
    "parBetterTitle": "Par or better by player",
    "parBetterEmpty": "No par-or-better scores yet.",
    "parBetterHoles": "Holes: {holes}",
    "parBetterHolesWithResult": "Holes: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Unknown player",
    "unknownGame": "Unknown game",
    "unknownWinner": "Unknown winner",
    "unknownMysteryPrize": "Unknown mystery prize",
    "reopenRoundButton": "Reopen round",
    "doneButton": "OK",
    "shotTrackingTitle": "Shot tracking",
    "shotTrackingHole": "Hole {hole}",
    "shotTrackingShots": "{count} strokes",
    "shotTrackingPutts": "{putts} putts"
  },
  "games": {
    "definitions": {
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "name": "Copenhagen",
        "info": "Three-player game: best net each hole scores 4, middle 2, worst 0.",
        "description": "Köpenhamn is a three-player game scored on net strokes hole-by-hole. The best net earns 4 points, the middle 2, and the worst 0. Tied players split the combined points evenly (tie for best 3/3/0, tie for worst 4/1/1, all tied 2/2/2). Most points after the round wins."
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "name": "Stableford",
        "info": "Points game based on score versus par on each hole.",
        "description": "Players earn points per hole from net performance against par."
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "name": "Stroke Play",
        "info": "Lowest total strokes wins.",
        "description": "Players are ranked by gross strokes across the round, with lower totals placing higher."
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "name": "Skins",
        "info": "Each hole is worth one skin.",
        "description": "The best score on a hole wins the skin; ties carry to the next hole."
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "name": "Best Ball",
        "info": "Team format using the best score on each hole.",
        "description": "Each team counts its best player score per hole."
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "name": "Best ball - worst ball",
        "info": "Team game comparing best and next net scores each hole.",
        "description": "Teams compare ordered net scores position-by-position each hole. Lower net in each comparison earns one point."
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "name": "Bunker",
        "info": "Event game for bunker outcomes.",
        "description": "Tracks bunker-related outcomes during the round."
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "name": "Water",
        "info": "Event game for water hazards.",
        "description": "Tracks water-hazard outcomes during the round."
      },
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "name": "3 Putts",
        "info": "Event game for three-putt outcomes.",
        "description": "Tracks holes where players need three putts."
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "name": "Chip In",
        "info": "Event game for chip-in achievements.",
        "description": "Awards one point each time a player chips in on a hole."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery prize",
        "info": "Secret side game with a selected subgame and hole.",
        "description": "Each player gets a hidden subgame for a selected hole, then a winner is chosen."
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "name": "Eclectic",
        "info": "Best Stableford points per hole across all tour rounds.",
        "description": "A tour-long game: for every hole, your best Stableford points from any round in the tour count. The composite 18-hole total is your Eclectic score."
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "name": "Eclectic Freeze",
        "info": "Lock in Stableford points on chosen holes after each round.",
        "description": "A tour-long gamble: after each round you lock the Stableford points on holes you are happy with. Locked holes can never change. Holes still open going into the final round take whatever you score there."
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "name": "Bingo Bango Bongo",
        "info": "Fun / points game",
        "description": "Points awarded for first on green, closest to pin, and first to hole out."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "name": "Birdie Or Better",
        "info": "Achievement",
        "description": "Par or better on each hole gives one point."
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "name": "High-Low",
        "info": "Team game",
        "description": "Team score is the sum of the highest and lowest individual scores on each hole."
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "name": "Nassau",
        "info": "Match play / betting",
        "description": "Three separate competitions: front nine, back nine, and overall 18 holes."
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "name": "Penalty",
        "info": "Hazard game",
        "description": "Count penalty strokes per hole. Last person with a hazard gets -1."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "name": "Sandy Par",
        "info": "Achievement",
        "description": "Bunker and still par or better gives one point."
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "name": "Vegas",
        "info": "Betting game",
        "description": "Team scores are combined into a two-digit number per hole, creating large score swings."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "name": "Wet Par",
        "info": "Achievement",
        "description": "Water hazard and still par or better gives one point."
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "name": "Wolf",
        "info": "Strategic team game",
        "description": "A rotating player (the Wolf) chooses partners or plays alone against the group."
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "name": "Worst Ball",
        "info": "Team game",
        "description": "For each hole, the highest score from any player on the team counts as the team score."
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "name": "Irish",
        "info": "Team game where more scores count as the round goes on.",
        "description": "A team game scored in net Stableford points, where the number of scores that count grows through the round. Over eighteen holes the best ball counts on the first six, the best two on the next six, the best three on the next four and every score on the closing two. A nine-hole round ramps the same way. The count never exceeds the team size, and the most points wins."
      }
    },
    "ruleSets": {
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "standard": {
          "name": "Standard",
          "description": "A putting side game. A hole on which you take three putts or more is worth one point, and it counts once however many putts it actually took. It is the quickest way to see whose short game let them down."
        }
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "standard": {
          "name": "Standard",
          "description": "Two points are on offer every hole. The teams line up their net scores in order and compare them one against one: best ball against best ball, then next ball against next ball. Each comparison is won by the lower net score, so taking both wins the hole outright and splitting them halves it. It asks a team to have both a low round and no passengers."
        }
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "standard": {
          "name": "Standard",
          "description": "A team game where only the best ball counts. On each hole the team takes its lowest net score and ignores the rest, so one player can carry a hole while the others pick up. Every player who matches that best score earns the point, which rewards two team-mates playing the hole well together."
        },
        "gross": {
          "name": "Gross",
          "description": "The same best-ball format played off scratch. No handicap strokes are given, so the team's lowest actual score on the hole is the one that counts."
        }
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "standard": {
          "name": "Standard",
          "description": "Three points are available on every hole, and they reward position rather than raw length. One goes to the first ball on the green, one to whoever is closest to the pin once every ball is on, and one to the first player in the hole. Order of play matters, so the shortest hitter can score as freely as anyone."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "standard": {
          "name": "Standard",
          "description": "One point for every hole you play in one under par or better, so a birdie, an eagle and an albatross each count once. It is judged on actual strokes rather than net score, which means handicap gives no help here. A simple way to reward the brave holes in an otherwise ordinary round."
        }
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "standard": {
          "name": "Standard",
          "description": "A side game that counts sand rather than scores. A hole on which you are in a bunker is worth one point, and a hole counts at most once however many times you visit. Agree before the round whether these points are worth having or worth dodging."
        }
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "standard": {
          "name": "Standard",
          "description": "One point every time you hole out from off the green, whether that is a chip, a pitch or a bunker shot. A hole can only score once, and it is recorded as it happens rather than worked out from your score. Pure luck counts the same as pure skill."
        }
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "standard": {
          "name": "Standard",
          "description": "A game that runs across the whole tour rather than a single round. For every hole, only your best Stableford score on it from any round in the tour counts, and a better score later replaces an earlier one. Your eclectic total is those eighteen best holes added together, so one good hole is banked for the rest of the tour."
        }
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "standard": {
          "name": "Standard",
          "description": "Eclectic with a gamble attached. After each round you choose which holes to freeze, locking in the Stableford points you scored on them, and a frozen hole can never change again for better or worse. Holes you leave open keep whatever you score on them in the last round, so freezing too early wastes a good hole and freezing too late risks losing one."
        }
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "standard": {
          "name": "Standard",
          "description": "Two separate points on every hole. The teams compare their best net ball against each other, and their worst net ball against each other, and each comparison is worth a point. It keeps a struggling player in the game, because the low half of the hole is just as valuable as the high half."
        }
      },
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "standard": {
          "name": "Standard",
          "description": "A three-player game where six points are shared on every hole by net score. The best ball takes four, the middle takes two and the worst takes none. Players who tie share the points for the places they occupy, so a tie for the lead is three each and a tie for last is four to the winner and one apiece. Anyone without a score for the hole ties for the places at the bottom."
        }
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "standard": {
          "name": "Standard",
          "description": "A hole is drawn in secret before the round starts, and nobody is told which one. Everyone plays all eighteen as normal, and only afterwards is the hole revealed and the best score on it takes the prize. Since you never know which hole counts, the only way to play it is to play every hole properly."
        }
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "standard": {
          "name": "Standard",
          "description": "Three matches played at once on a single round: the front nine, the back nine, and the full eighteen. Each is settled separately, so losing the front nine costs you one match and nothing more. A player who is down may call a press, which starts a brand-new match running from that hole to the end of the segment, giving a way back without touching the matches already under way."
        },
        "front-back-only": {
          "name": "Front and back only",
          "description": "The same two nine-hole matches, front and back, with no separate match over the full eighteen. A good front nine is banked rather than being reopened by the overall match, which suits a group that would rather play two short contests than one long one. Presses work exactly as they do in the full game."
        }
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "standard": {
          "name": "Standard",
          "description": "A side game for the strokes nobody wants. A hole on which you take a penalty is worth one point, counted once per hole however the penalty came about. As with the other trouble games, decide beforehand whether the winner is the one with most or fewest."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "standard": {
          "name": "Standard",
          "description": "The reward for getting out of trouble cleanly. If you were in a bunker on a hole and still finished it in par or better, that hole is worth one point. It is judged on actual strokes, so it is the up-and-down that earns it and nothing else."
        }
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "standard": {
          "name": "Standard",
          "description": "Every hole is worth one skin. The skin goes to whoever has the single lowest net score, and only outright: if two or more share the best score, nobody wins it. A tied hole rolls its skin onto the next one, so the pot keeps growing until somebody wins a hole alone and takes the lot. A quiet round can turn on one hole late."
        },
        "no-carry": {
          "name": "No carry",
          "description": "Every hole is worth one skin, won outright by the single lowest net score. A tied hole is simply void: nothing rolls forward and that skin is gone. Each hole is therefore worth at most one skin, which keeps the game steady instead of letting one late hole decide everything."
        }
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "standard": {
          "name": "Standard",
          "description": "Each hole is worth points against par on your net score. A par is two points, with one more for every stroke better and one fewer for every stroke worse; a hole never scores below zero, so a blow-up costs you nothing extra. Strokes are given by handicap: one on every hole, plus an extra on the hardest holes by stroke index until your handicap runs out. Picking up scores zero for that hole. The highest total after the round wins."
        },
        "gross": {
          "name": "Gross",
          "description": "The same points table, but played off scratch. Nobody receives strokes, so the score on the card is the score that counts. Everything else is unchanged: a par is two points, better is more, worse is fewer, and no hole goes below zero."
        }
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "standard": {
          "name": "Standard",
          "description": "Straight golf: count every stroke and add them up. Handicap strokes are deducted, so the total is your net score for the round and the lowest total wins. There is nothing to manage hole by hole, which makes it the fairest read on who actually played best."
        },
        "gross": {
          "name": "Gross",
          "description": "The same count of every stroke, played off scratch. No handicap is deducted, so the lowest number of actual strokes wins. This is how a club championship is decided."
        }
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "standard": {
          "name": "Standard",
          "description": "A pair's two net scores are pushed together into one two-digit number, lowest ball first: a four and a six becomes forty-six, not sixty-four. The two teams compare numbers and the difference between them is the score for the hole. Because a bad ball moves the second digit, one poor score costs far more here than in most team games."
        }
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "standard": {
          "name": "Standard",
          "description": "A side game that keeps score of trouble rather than good play. A hole where you find the water is worth one point, and a hole counts at most once no matter how many times you go in. Whether the points are something to collect or something to avoid is for the group to settle before the round."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "standard": {
          "name": "Standard",
          "description": "The same reward, but for water rather than sand. Find the water on a hole and still finish it in par or better, and the hole is worth one point. Given the penalty stroke that usually comes with it, this is the harder of the two to earn."
        }
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "standard": {
          "name": "Standard",
          "description": "The players take turns being the wolf, in a fixed order that rotates each hole. The wolf tees off last and watches the others, then either picks one of them as a partner for the hole or turns everyone down and plays alone against the rest. Going alone is worth more if it comes off and costs more if it does not, so the whole game is in the timing of that decision."
        }
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "standard": {
          "name": "Standard",
          "description": "The mirror of best ball, and far harder than it sounds. On each hole the team's highest net score is the one that counts, so nobody can hide and every player has to finish the hole. Every player on that score earns the point. It punishes one loose hole in a way best ball never does."
        }
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "standard": {
          "name": "Standard",
          "description": "Teams collect net Stableford points, and the number of scores that count grows as the round goes on. It begins with only the best ball in the team, then the best two after a third of the round, the best three after two thirds, and every score over the closing holes: six, six, four and two across eighteen holes, or three, three, two and one across nine. The count never exceeds the team size, so a pair simply reaches its cap early. Every player carries the team's total."
        }
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Closest to flag",
        "description": "Closest to the flag on the chosen hole."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Longest drive",
        "description": "Longest drive on the chosen hole."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Longest 1 putt",
        "description": "Longest single putt on the chosen hole."
      },
      "f0385fe1-a689-433a-ae70-480532077b12": {
        "name": "Other",
        "description": "Any other challenge the players agree on for the chosen hole."
      }
    }
  },
  "freeze": {
    "title": "Eclectic Freeze",
    "subtitle": "Lock in Stableford points on holes you are happy with. Locked holes never change.",
    "loading": "Loading…",
    "loadError": "Could not load Eclectic Freeze.",
    "noPlayers": "No players to show yet.",
    "chipLockedCount": "{locked} locked",
    "lockedAvg": "avg {avg}",
    "selectHint": "Pick holes to lock for {name}.",
    "windowClosed": "The lock window is closed for this player.",
    "windowOtherRound": "This player locks from another round.",
    "openEarlierLabel": "Open this earlier round for freezing",
    "openEarlierHint": "Tick the box to lock holes from this round anyway.",
    "allLocked": "All holes are locked.",
    "lockedTotalLabel": "Locked",
    "selectedLabel": "Selected",
    "afterLockLabel": "After lock",
    "avgLabel": "Avg",
    "lockButton": "Lock {count} holes",
    "saving": "Locking…",
    "permanentNote": "Locking is permanent. The window closes when the next round starts.",
    "confirmTitle": "Lock holes?",
    "confirmMessage": "Lock {count} holes for {name}? This cannot be undone.",
    "confirmCta": "Lock permanently",
    "cancel": "Cancel",
    "lockSaved": "{count} holes locked.",
    "lockRejected": "Could not lock holes.",
    "lockTimeout": "No response. Try again.",
    "switchTitle": "Discard selected holes?",
    "switchMessage": "You have {count} selected holes for {name} that are not locked yet. Switch player and discard them?",
    "switchCta": "Switch and discard",
    "switchStay": "Keep selection",
    "done": "Done"
  },
  "claimSignup": {
    "title": "Keep your scores",
    "body": "Create an account to keep your scores and use them on any device.",
    "cta": "Create account to keep your scores"
  },
  "privacy": {
    "title": "Privacy policy",
    "updated": "Last updated {date}",
    "intro": "Goffy records golf rounds. We keep what that needs and nothing more. We do not sell your data, show ads, or use third-party tracking.",
    "collectH": "What we collect",
    "collectP": "Your email address and password, your player name and — if you add them — handicap, gender and photo, plus the rounds and scores you play. The app also sends performance measurements so we can find faults.",
    "locationH": "Location",
    "locationP": "When you start a round we ask for your location to list nearby courses. The coordinates are used for that search only and are not stored. Refusing changes nothing else.",
    "sharingH": "Who sees it",
    "sharingP": "The people you play with see the rounds you share with them. Nobody else, unless the law requires it.",
    "storageH": "Where it is kept",
    "storageP": "On servers in Ireland, encrypted in transit. Rounds stay for as long as your account does.",
    "rightsH": "Your rights",
    "rightsP": "You can view and edit your profile, and delete your account under Profile in the menu. Deleting removes your login, your profile and your personal details. Scores stay on other players' scorecards, shown against your name, because removing them would rewrite someone else's round. To ask for a copy of your data, email privacy@goffy.app.",
    "contactH": "Contact",
    "contactP": "privacy@goffy.app"
  },
  "courseMapping": {
    "title": "Course mapping",
    "intro": "Goffy can learn where the tees and greens are on the courses you play, by recording your position during a round. It is off unless you turn it on.",
    "toggleLabel": "Help map the courses I play",
    "unsupported": "Course mapping is only available on Android for now.",
    "whatH": "What is recorded",
    "whatP": "Your position, about once every three seconds, while a round is in play. Recording stops when the round ends. Nothing is recorded between rounds.",
    "whyH": "What it is used for",
    "whyP": "Positions from many players are combined to work out where each tee and green is. The result is a map of the course, not a record of your round. Your positions are stored under a code that is different on every course, so they cannot be joined together into a history of where you have been.",
    "batteryH": "What it costs",
    "batteryP": "Expect to use roughly 10-15% more battery over a four-hour round. Recording never starts below 20% battery, and stops if you drop to 20% during a round.",
    "retentionH": "How long it is kept",
    "retentionP": "Raw positions are deleted after 90 days. The tee and green positions worked out from them are kept, because they are what the map is made of and they are not about any one player.",
    "controlH": "Staying in control",
    "controlP": "Turn this off at any time and recording stops immediately. Delete your account and your recorded positions are deleted with it. Once a course is fully mapped, Goffy stops recording there on its own."
  },
  "courseMappingReview": {
    "title": "Review course mapping",
    "intro": "Tee and green positions worked out from players' GPS traces. Each one is an average, and confidence says how much to trust it. Accept a position to make it official; reject to delete it.",
    "selectCourse": "Course",
    "empty": "Nothing derived for this course yet. Positions appear once enough rounds have been recorded.",
    "hole": "Hole {number}",
    "tee": "Tee",
    "green": "Green",
    "reviewed": "accepted",
    "meta": "{confidence}% confidence · {contributors} contributors",
    "accept": "Accept",
    "reject": "Reject"
  },
  "courseHoleMap": {
    "openButton": "View mapped holes",
    "title": "Course mapping",
    "overviewTitle": "Course overview",
    "overviewCounter": "{total} holes",
    "holeTitle": "Hole {hole}",
    "empty": "This course has no holes to show yet.",
    "meta": "{source} · {confidence}% confidence · {contributors} contributors",
    "shapeMeta": "{area} · {points} points · hole {hole}",
    "basemap_esri-worldimagery": "Esri",
    "basemap_lantmateriet-orto": "Lantmäteriet",
    "basemap_drawing": "Drawing",
    "source_esri-worldimagery": "Esri",
    "source_lantmateriet-orto": "Lantmäteriet",
    "source_osm": "OSM",
    "close": "Close",
    "shapeKind_bunker": "Bunker",
    "shapeKind_water": "Water",
    "shapeKind_green": "Green surface",
    "shapeKind_fairway": "Fairway",
    "shapeKind_trees": "Trees",
    "counter": "{index} of {total} holes",
    "edit": "Edit positions",
    "editDone": "Done editing",
    "placeTee": "Add tee",
    "placeGreen": "Set green",
    "revert": "Undo changes",
    "save": "Save",
    "saving": "Saving…",
    "saved": "Positions saved. Imagery analysis has been queued for this course.",
    "saveFailed": "Could not save the positions. Nothing was changed.",
    "remove": "Remove",
    "editHint": "Choose Add tee or Set green, then click the spot on the map. Drag to pan; the coordinate shown is the centre of the view.",
    "armedHint": "Click the map to place it.",
    "unsavedWarning": "Save or undo the changes to this hole first.",
    "closeWarning": "Close again to discard the unsaved changes.",
    "goto": "Go",
    "gotoPlaceholder": "Latitude, longitude",
    "gotoInvalid": "Could not read that as a latitude and longitude. Try \"56.6776, 12.8578\".",
    "analyse": "Analyse",
    "analysing": "Queueing…",
    "analysisQueued": "Queued for imagery analysis. It runs within a few minutes.",
    "analysisUnavailable": "Imagery analysis is not configured in this environment.",
    "analysisFailed": "Could not queue imagery analysis.",
    "savedAndMoved": "Saved. The course position was a long way from this, so it has been moved here and queued for analysis.",
    "basemapUnavailable": "No Lantmäteriet imagery stored for this course yet."
  },
  "subscriptionPage": {
    "title": "Subscription",
    "signInPrompt": "Sign in to manage your subscription.",
    "loading": "Loading your subscription status…",
    "error": "Could not load your subscription status.",
    "statusNone": "You don't have an active subscription yet.",
    "statusActive": "Your subscription is active. Renews {date}.",
    "statusActiveCancelling": "Your subscription is active until {date}, then it will end.",
    "statusPastDue": "Your last payment failed. Update your payment method to keep your subscription.",
    "statusCancelled": "Your subscription has ended.",
    "upgradeButton": "Subscribe",
    "manageButton": "Manage subscription",
    "checkoutError": "Could not start checkout. Try again.",
    "portalError": "Could not open subscription management. Try again.",
    "featureDisabled": "Subscriptions aren't available yet.",
    "successMessage": "Thanks! Your subscription is being set up.",
    "cancelledMessage": "Checkout was cancelled."
  },
  "subscriptionAdminPage": {
    "title": "Payments & subscriptions",
    "forbidden": "Admins only.",
    "loading": "Loading subscriptions…",
    "error": "Could not load subscriptions.",
    "empty": "No subscriptions yet.",
    "status": "Status",
    "cancelling": "cancelling",
    "price": "Price",
    "renews": "Renews",
    "updated": "Updated",
    "stripeIds": "Stripe customer / subscription"
  },
  "golfCourseAdminPage": {
    "title": "Golf course admin",
    "forbidden": "Admins only.",
    "totalCourses": "{count} courses in the catalogue",
    "loadingCourses": "Loading courses…",
    "loadCoursesError": "Could not load courses.",
    "searchPlaceholder": "Search courses by name, club or id",
    "searchNoMatches": "No courses match.",
    "filterAll": "All",
    "filterAnalysed": "Analyzed",
    "filterNotAnalysed": "Not analyzed",
    "countryAll": "All countries",
    "selectAllShown": "Select all shown",
    "selectedCount": "{count} selected",
    "analyzeSelected": "Analyze selected",
    "clearSelection": "Clear",
    "pageRange": "{from}–{to} of {total} · page {page}/{pages}",
    "previousPage": "Previous",
    "nextPage": "Next",
    "osmFilterGreens": "OSM greens",
    "osmFilterHoles": "OSM holes",
    "osmFilterBunkers": "OSM bunkers",
    "osmFilterFairways": "OSM fairways",
    "courseCardOsmFeatures": "OSM data: {greens} greens · {holes} holes · {bunkers} bunkers · {fairways} fairways",
    "analysisUnknown": "Unknown",
    "courseCardDetails": "Par {par} · {holes} holes · {visibility}",
    "courseCardCoordinates": "{lat}, {lon}",
    "courseCardOsm": "OSM {osmType}/{osmId}",
    "osmSectionTitle": "OSM data found",
    "osmNotImported": "Not imported from OSM.",
    "osmCountsError": "Could not fetch OSM data.",
    "osmCounts": "{holes} holes · {greens} greens · {tees} tees · {terrain} terrain features",
    "analysisSectionTitle": "What we have analyzed",
    "findOsmButton": "Find OSM golf courses",
    "modalTitle": "Import golf courses from OpenStreetMap",
    "countryLabel": "Country",
    "withHoleDataLabel": "With hole data only",
    "importButton": "Import",
    "importing": "Importing…",
    "progressSearching": "Searching OpenStreetMap…",
    "progressFound": "Found {count} courses",
    "progressCheckingHoleData": "Checking hole data: {checked}/{total}",
    "progressCheckingHoleDataWithImports": "Checking hole data: {checked}/{total} ({imported} imported so far)",
    "progressImporting": "Importing {count} courses…",
    "resultSummary": "Imported {imported}, skipped {skipped} already existing",
    "resultFailed": "{failed} could not be imported",
    "importedListTitle": "Imported courses",
    "error": "Import failed. Try again.",
    "backfillButton": "Backfill missing analysis",
    "backfillRunning": "Backfilling…",
    "backfillProgress": "{matched} matched via OSM, {triggered} triggered without a match, {failed} failed",
    "backfillDone": "Done: {matched} matched via OSM, {triggered} triggered without a match, {failed} failed",
    "backfillError": "Backfill failed. Try again.",
    "close": "Close",
    "flyoverButton": "Flyover",
    "flyoverModalTitle": "Render flyovers: {name}",
    "flyoverExplainer": "Flyover videos are rendered locally, once per course (Lantmäteriet coverage required). Copy the command and paste it into a terminal at the repo root — the script opens a sign-in link; approve it in the browser you are already logged in with. Needs AWS credentials, ffmpeg, and the course-analysis Python venv. Drop --dry-run to upload the result.",
    "flyoverCopy": "Copy command",
    "flyoverCopied": "Copied",
    "flyoverWorkerExplainer": "Flyover videos are rendered by a batch worker on your own machine (Lantmäteriet coverage required). Queue the render here; it starts when a worker is online and the course fills in hole by hole.",
    "flyoverRender": "Render on batch worker",
    "flyoverRequesting": "Queuing…",
    "flyoverQueued": "Queued. The videos appear as each hole finishes.",
    "flyoverRenderFailed": "Could not queue the render.",
    "flyoverNoHoles": "No hole has both a tee and a green; nothing to fly.",
    "flyoverWorkerOnline": "A batch worker is online.",
    "flyoverWorkerOffline": "No batch worker is online — the job waits until one is switched on.",
    "flyoverLastJob": "Last render: {status} ({rendered} rendered, {skipped} skipped)",
    "flyoverShowCommand": "Render on this laptop instead…",
    "flyoverHideCommand": "Hide the laptop command",
    "flyoverJobStatus": {
      "queued": "queued",
      "succeeded": "succeeded",
      "failed": "failed"
    },
    "osmRefreshButton": "Refresh OSM",
    "osmRefreshRunning": "Refreshing OSM…",
    "osmRefreshResult": "OSM refreshed: {written} new, {updated} updated, {removed} removed, {unchanged} unchanged",
    "osmRefreshFailed": "OSM refresh failed"
  },
  "deleteAccountPage": {
    "title": "Delete your Goffy account",
    "updated": "Last updated {date}",
    "intro": "You can delete your Goffy account at any time. This page explains what is removed, what stays, and how to do it.",
    "removedH": "What is deleted",
    "removedP": "Your login, your profile and the personal details on it — photo, handicap, gender and home clubs. Deletion is permanent and cannot be undone.",
    "keptH": "What stays",
    "keptP": "Rounds and tours you played stay on the other players' scorecards, still shown against your name, because removing them would rewrite someone else's round.",
    "inAppH": "From the app",
    "inAppP": "Open the menu, go to Profile, and use Delete my account at the bottom of the screen.",
    "signedOutH": "If you cannot sign in",
    "signedOutP": "Email privacy@goffy.app from the address on the account and we will delete it for you."
  },
  "terms": {
    "title": "Service conditions",
    "updated": "Last updated {date}",
    "intro": "Goffy records golf rounds. These are the conditions for using it. Short version: be respectful, use Goffy for golf, and keep your account secure.",
    "accountH": "Your account",
    "accountP": "You are responsible for what happens on your account. Keep your password to yourself, and use a name your playing partners will recognise — scorecards are shared with the people you play with.",
    "fairUseH": "Fair use",
    "fairUseP": "Do not abuse, attack or disrupt the service, and do not use it to harass other players. We may close an account that does.",
    "dataH": "Your data",
    "dataP": "We store the account data needed to run the service and nothing more. What we collect, where it is kept and how to have it removed is described in the privacy policy.",
    "warrantyH": "No warranty",
    "warrantyP": "Goffy is provided as-is. We do our best to keep scores safe and the service running, but we cannot guarantee it is free of faults or always available, and a result recorded here is not an official handicap record.",
    "changesH": "Changes",
    "changesP": "These conditions may be updated over time. The date above changes when they do."
  },
  "about": {
    "title": "About",
    "version": "Version",
    "build": "Build",
    "commit": "Commit",
    "buildDate": "Build date",
    "licensesHeading": "Open source licenses",
    "licensesIntro": "Goffy is built with {count} open-source packages. Tap one to see its license.",
    "licenseTextUnavailable": "License text not available.",
    "close": "Close"
  },
  "ai": {
    "playAgainstAi": "Play against AI players",
    "revealMode": "AI results",
    "revealInAdvance": "Show in advance",
    "revealAsIScore": "Reveal as we score",
    "addAiPlayer": "Add AI player",
    "pureAi": "AI player",
    "ghostOfMe": "Ghost of me",
    "ghostOfFriend": "Ghost of a friend",
    "aiBadge": "AI",
    "ghostBadge": "Ghost",
    "pendingReveal": "Revealed after everyone scores",
    "ghostNamePrefix": "Ghost of {name}",
    "aiCreateFailed": "Could not create the AI player. Please try again.",
    "aiPlayersHint": "AI players and humans share the same list — max {count} in total."
  },
  "courseAnalysis": {
    "title": "Course data analysis",
    "adminOnly": "This page is only available to administrators.",
    "failed": "Could not load the course's data.",
    "empty": "No mapped data for this course yet.",
    "holeTitle": "Hole {hole}",
    "unattributed": "Not attributed to a hole",
    "reports": "Reports",
    "reportBadge": "{count} reported inaccurate",
    "noFeatures": "No mapped features.",
    "meta": "Confidence {confidence}% · {state}",
    "reviewed": "reviewed",
    "unreviewed": "unreviewed",
    "polygon": "polygon",
    "centreOnly": "centre point only, no boundary",
    "sampleCount": "{count} contributors",
    "kind": {
      "tee": "Tee",
      "green": "Green",
      "bunker": "Bunker",
      "water": "Water",
      "other": "Other",
      "fairway": "Fairway",
      "trees": "Trees"
    },
    "source": {
      "osm": "OSM",
      "gps": "GPS",
      "satellite": "Satellite"
    },
    "guide": {
      "title": "Course guide — hole {hole}",
      "length": "{metres} m",
      "unavailable": "Not enough geometry to draw this hole. A tee and a green are the minimum.",
      "arcsNote": "Arcs are metres to the front edge of the green.",
      "missingCover": "No {kinds} mapped yet — re-run the satellite analysis to fill the picture in.",
      "derivedNotice": "Drawn from unreviewed satellite analysis. Fairway edges are separated from rough by mowing height alone and the tree line is a shadow gradient; treat every boundary as a candidate.",
      "nothingMapped": "No boundaries mapped for this hole — only the tee and green positions are known. Satellite analysis has not produced polygons for this course yet."
    },
    "status": {
      "open": "Course analysis",
      "title": "Course analysis",
      "failed": "Could not load the analysis status.",
      "endpointMissing": "This backend does not have the analysis endpoint yet. The frontend is ahead of geodata-service — deploy it (the migration applies on startup) and this panel will fill in.",
      "attempts": "Attempt {attempts} of {max}",
      "requestedAt": "Requested",
      "analysedAt": "Analysed",
      "never": "never",
      "lastRun": "Last run",
      "neverRun": "No analysis pass has ever run for this course.",
      "durationSeconds": "Took {seconds} s",
      "durationMinutes": "Took {minutes} min {seconds} s",
      "stored": "Stored features",
      "noFeatures": "No features stored for this course.",
      "featureMeta": "{count} from {source} · {polygons} with boundaries",
      "run": "Run analysis now",
      "running": "Requesting…",
      "queued": "Queued. The analyser picks it up within a few minutes; reopen this panel to see the result.",
      "runFailed": "Could not request analysis.",
      "queueDepth": "Analysis queue",
      "queueDepthCount": "{count} waiting across all courses",
      "queueDepthUnknown": "Could not read the queue size.",
      "worker": "Batch worker",
      "workerOnline": "A worker is online and takes queued analyses.",
      "workerOffline": "No worker is online. Queued analyses wait until one is switched on.",
      "workerRow": "{id} · release {version}",
      "workerVersionUnknown": "dev build",
      "workerBusy": "busy",
      "state": {
        "disabled": "Disabled",
        "neverRequested": "Never requested",
        "pending": "Pending",
        "abandoned": "Abandoned",
        "analysed": "Analysed"
      },
      "explain": {
        "disabled": "No imagery analyser is configured in this environment, so no course can be analysed. This is a deployment and configuration matter, not something re-running will fix.",
        "neverRequested": "This course has never been queued for analysis — it was most likely imported before the feature existed. Running it now is all it needs.",
        "pending": "Queued and waiting for the background loop, which claims courses on a timer.",
        "abandoned": "Analysis failed its attempts and will not be retried on its own. See the last run below for why, then run it again once the cause is addressed.",
        "analysed": "A pass completed for this course. The last run below says what it produced."
      },
      "providerLine": "{provider}: {written} written, {replaced} replaced, {skipped} skipped (stronger source) · tiles {fetched}/{attempted}",
      "providerFailed": "failed: {error}",
      "providerPartial": "imagery incomplete",
      "runStatus": {
        "running": "Running",
        "dispatched": "Waiting for worker",
        "succeeded": "Succeeded",
        "partial": "Partial",
        "failed": "Failed"
      }
    }
  },
  "shotTrackingDebug": {
    "title": "Shot tracking debug",
    "developersOnly": "This page is only available to developers.",
    "status": "Status",
    "audio": "Live audio",
    "noAudio": "No metering — the microphone opens while you stand still, or the moment the putt test runs.",
    "simulate": "Simulate impact",
    "simulated": "Impact injected into the live pipeline.",
    "noSession": "Audio capture unavailable on this device — wrist peaks from the watch still appear.",
    "clear": "Clear log",
    "startSession": "Start test session",
    "stopSession": "Stop test session",
    "sessionFailed": "Could not start a test session: {reason}",
    "puttTest": "Putt test",
    "puttTestHint": "Holds the microphone open (works indoors, no GPS needed) and sends nothing to the round. The page proposes a candidate for every putt it hears or feels — judge each one, and press \"Missed putt\" when you putted and nothing was proposed. Candidates born at a button press are discounted as tap noise.",
    "puttTestStart": "Start putt test",
    "puttTestStop": "Stop putt test",
    "marks": "Marks sent from this device",
    "server": "Fused shots from the server",
    "log": "Event log",
    "none": "Nothing yet.",
    "close": "Close",
    "judgePrompt": "judge below",
    "listening": "Listening — putt when ready.",
    "verdictCorrect": "Correct putt",
    "verdictWrong": "Not a putt",
    "verdictMissed": "Missed putt",
    "puttEstimateSummary": "{correct} correct · {wrong} wrong · {missed} missed · {pending} unjudged"
  },
  "schedule": {
    "title": "Schedule round",
    "heading": "Schedule a round",
    "teeTimeLabel": "Tee time",
    "pickTeeTime": "Pick tee time",
    "pickCourse": "Course",
    "nameLabel": "Round name (optional)",
    "namePlaceholder": "Round name",
    "holesLabel": "Holes",
    "holes18": "18 holes",
    "holes9": "9 holes",
    "submit": "Schedule round",
    "submitting": "Scheduling...",
    "success": "Round scheduled.",
    "missingCourse": "Pick a course first.",
    "missingTeeTime": "Pick a tee time first.",
    "error": "Could not schedule the round.",
    "rejected": "The round could not be scheduled.",
    "creatingTour": "Preparing...",
    "upcomingTitle": "Upcoming rounds",
    "scheduleRoundCta": "Schedule round",
    "notifyByEmail": "Send email invites",
    "notifyByEmailHint": "Members always see it in the app — email is optional."
  },
  "rsvp": {
    "title": "RSVP",
    "heading": "Are you coming?",
    "teeTime": "Tee time",
    "course": "Course",
    "accept": "Accept",
    "decline": "Decline",
    "maybe": "Maybe",
    "whoIsComing": "Who's coming",
    "respondedAt": "Responded {time}",
    "noResponses": "No responses yet.",
    "comingCount": "{count} coming",
    "loading": "Loading...",
    "loadError": "Could not load the round.",
    "sending": "Saving your answer...",
    "sendError": "Could not save your answer.",
    "statusInvited": "Invited",
    "statusAccepted": "Coming",
    "statusDeclined": "Not coming",
    "statusTentative": "Maybe",
    "myStatusLabel": "Your answer"
  },
  "mlModels": {
    "open": "Models",
    "close": "Close",
    "title": "Detector models",
    "unavailable": "The backend has no model registry yet.",
    "failed": "Could not load the model registry.",
    "empty": "No models registered yet. Train one with training/train.py --register.",
    "model": "Model",
    "score": "P {p} · R {r} · F1 {f1}",
    "legend": "Latest evaluation per kind: precision · recall · F1 against OSM/accepted features.",
    "datasets": "{count} registered dataset(s)."
  }
}
